'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState, useCallback, useMemo } from 'react';
import { createPortal } from 'react-dom';
import Link from '@/components/ui/Link';
import BigNewsWithicon from '@/components/component_astro_crick/BigNewsWithicon';
import BigNewsVideo from '@/components/component_astro_crick/BigNewsVideo';
import OnesideText from '@/components/component_astro_crick/OnesideText';
import ChipsForm from '@/components/component_form/ChipsForm';
import Form from '@/components/component_form/Form';
import HorizontalCommentsNews from '@/components/component_horizontal/HorizontalCommentsNews';
import HorizontalSmallVideoRightNews from '@/components/component_horizontal/HorizontalSmallVideoRightNews';
import AudioPlayer from '@/components/component_unique/AudioPlayer';
import Divider from '@/components/component_unique/divider';
import EmojiRating from '@/components/component_unique/EmojiRating';
import FollowUsFacebook from '@/components/component_unique/FollowUsFacebook';
import FollowUsTwitter from '@/components/component_unique/FollowUsTwitter';
import SocialMediaButtons from '@/components/component_unique/SocialMediaButtons';
import PdfFile from '@/components/component_unique/PdfFile';
import TweetEmbed from '@/components/component_unique/TweetEmbed';
import InstagramEmbed from '@/components/component_unique/InstagramEmbed';
import VideoEmbed from '@/components/component_unique/VideoEmbed';
import GumletEmbed from '@/components/component_unique/GumletEmbed';
import TableEmbed from '@/components/component_unique/TableEmbed';
import PhotoCarousel from '@/components/component_unique/PhotoCarousel';
import ArticleShareButtons from '@/components/component_unique/ArticleShareButtons';
import SocialIcons from '@/components/header/SocialIcons';
import Button from '@/components/ui/buttons';
import { MessageIconLogo } from '@/components/ui/message-icon-logo';
import { BOOKMARK_CATEGORIES } from '@/lib/api/public-client';
import Ad from '@/components/ads/Ad';
import HorizontalSmallImageCategoryNews from '@/components/component_horizontal/HorizontalSmallImageCategoryNews';
import HorizontalSmallRightImageCategoryNews from '@/components/component_horizontal/HorizontalSmallRightImageCategoryNews';
import ImageVideo from '@/components/PageComponents/ImageVideo';
import ArticleMultiAds from '@/components/ads/ArticleMultiAds';
import AdvertisePopup from '@/components/ads/AdvertisePopup';
import { useDevice } from '@/contexts/DeviceContext';
import { AD_UNITS, SOCIAL_MEDIA_LINKS, FALLBACK_IMAGE, API_BASE_URL, API_ENDPOINTS } from '@/lib/constants';
import { extractTextFromCards, formatTimestamp, formatTimeAgo, getImageUrl, parseAdCode, ArticleAdResponse } from '@/lib/api';
import { ARTICLE_AD_SLOT_NAMES } from '@/lib/constants';
import { processArticleLinks } from '@/lib/linkUtils';
import { getFocusPointStyle } from '@/lib/componentutills';
import { cleanAdCode, parseAdCode as parseGptAdCode, executeAdScripts, initGPT, setInfiniteScrollActive } from '@/lib/gpt-loader';
import { useAdSlot, useAllAdSlots, useWebsiteSetting } from '@/components/ads/AdDataProvider';
// Live blog refresh interval (30 seconds)
const LIVE_BLOG_REFRESH_INTERVAL = 30000;
import { useBooleanSetting, useStringSetting } from '@/lib/WebsiteSettingsContext';
import { generateArticleSchemaFromStory, generateLiveBlogPostingSchemaFromStory, generateBreadcrumbSchemaFromStory } from '@/lib/schema';

// Vuukle Widgets — sharebar, emotes & comments, each in its own iframe for isolation
// (Vuukle hardcodes element IDs, so multiple instances need separate DOMs)
const VuukleWidgets = t0 => {
  const $ = _c(12);
  const {
    articleId,
    articleTitle,
    articleImage,
    articleTags,
    articleAuthor
  } = t0;
  const iframeRef = useRef(null);
  let t1;
  if ($[0] !== articleAuthor || $[1] !== articleId || $[2] !== articleImage || $[3] !== articleTags || $[4] !== articleTitle) {
    t1 = JSON.stringify({
      apiKey: "6f27340a-c671-45a9-ae0c-13b8d5595b42",
      host: "dinamani.mo.vc",
      articleId,
      img: articleImage,
      tags: articleTags,
      url: "https://dinamani.mo.vc",
      title: articleTitle,
      author: articleAuthor,
      language: "en",
      recommendedArticles: false,
      globalRecommendations: false,
      wideImages: false,
      comments: {
        enabled: true,
        editorOptions: [],
        transliteration: {
          language: "ta",
          enabledByDefault: false
        },
        commentingClosed: false,
        countToLoad: 5
      },
      emotes: {
        enabled: false,
        disable: [5, 6]
      },
      sharebar: {
        enabled: false,
        verticalPosition: "10px",
        mode: "horizontal"
      }
    });
    $[0] = articleAuthor;
    $[1] = articleId;
    $[2] = articleImage;
    $[3] = articleTags;
    $[4] = articleTitle;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const vuukleConfig = t1;
  const iframeId = `vuukle-${articleId}`;
  const srcDoc = `<!DOCTYPE html><html><head><style>body{margin:0;padding:0;}#vuukle-comments{overflow:hidden;}.vuukle-powered-by,.vuukle-privacy,.vuukle-footer,div[class*="powered"],div[class*="privacy"]{margin-bottom:0!important;padding-bottom:0!important;}body>div:last-child{margin-bottom:0!important;padding-bottom:0!important;}</style></head><body><div id="vuukle-emote"></div><div id="vuukle-comments"></div><script>var VUUKLE_CONFIG=${vuukleConfig};(function(){var d=document,s=d.createElement('script');s.src='https://cdn.vuukle.com/platform.js';(d.head||d.body).appendChild(s)})();setInterval(function(){var els=document.querySelectorAll('body > *');var lastVisible=null;for(var i=els.length-1;i>=0;i--){var el=els[i];if(el.offsetHeight>0&&el.tagName!=='SCRIPT'){lastVisible=el;break;}}var h=lastVisible?(lastVisible.offsetTop+lastVisible.offsetHeight):document.body.scrollHeight;window.parent.postMessage({type:'vuukle-resize',id:'${iframeId}',height:Math.max(h,50)},'*');},500);<\/script></body></html>`;
  let t2;
  let t3;
  if ($[6] !== iframeId) {
    t2 = () => {
      const handler = e => {
        if (e.data?.type === "vuukle-resize" && e.data?.id === iframeId && e.data?.height) {
          const iframe = iframeRef.current;
          if (iframe) {
            iframe.style.height = e.data.height + "px";
          }
        }
      };
      window.addEventListener("message", handler);
      return () => window.removeEventListener("message", handler);
    };
    t3 = [iframeId];
    $[6] = iframeId;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      height: "100px"
    };
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== srcDoc) {
    t5 = <iframe ref={iframeRef} srcDoc={srcDoc} className="w-full border-0" style={t4} title="Vuukle Widgets" />;
    $[10] = srcDoc;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};

// Shadow DOM component for rendering isolated HTML (prevents style leaks)
const ShadowDomHtml = t0 => {
  const $ = _c(4);
  const {
    html
  } = t0;
  const hostRef = useRef(null);
  const shadowRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== html) {
    t1 = () => {
      if (!hostRef.current || !html) {
        return;
      }
      if (!shadowRef.current) {
        shadowRef.current = hostRef.current.attachShadow({
          mode: "open"
        });
      }
      shadowRef.current.innerHTML = html;
    };
    t2 = [html];
    $[0] = html;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div ref={hostRef} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};

// Arrow Icons for single mode navigation (bold) - responsive sizes
const ChevronLeftIcon = t0 => {
  const $ = _c(3);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M15 18l-6-6 6-6" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== className) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className={className}>{t2}</svg>;
    $[1] = className;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};
const ChevronRightIcon = t0 => {
  const $ = _c(3);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M9 18l6-6-6-6" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== className) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className={className}>{t2}</svg>;
    $[1] = className;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};

// Helper function to extract path from URL (removes domain if present)
const getPathFromUrl = (urlOrSlug: string): string => {
  if (!urlOrSlug) return '';
  // Remove domain if present (handles both with and without trailing slash)
  const cleanPath = urlOrSlug.replace(/^https?:\/\/(www\.)?dinamani\.com\/?/, '').replace(/^\/+/, ''); // Remove leading slashes
  return cleanPath;
};

// Helper function to add parameters to YouTube embed URL to hide overlays
const getCleanYouTubeUrl = (embedUrl: string, autoplay: boolean = false): string => {
  if (!embedUrl) return '';
  try {
    const url = new URL(embedUrl);
    url.searchParams.set('modestbranding', '1');
    url.searchParams.set('rel', '0');
    url.searchParams.set('showinfo', '0');
    url.searchParams.set('iv_load_policy', '3'); // Hide annotations
    url.searchParams.set('disablekb', '0');
    if (autoplay) {
      url.searchParams.set('autoplay', '1');
    }
    return url.toString();
  } catch {
    return embedUrl;
  }
};

// YouTube Video Component - directly shows YouTube iframe
const YouTubeThumbnail = t0 => {
  const $ = _c(6);
  const {
    embedUrl,
    title
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      paddingBottom: "56.25%"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== embedUrl) {
    t2 = getCleanYouTubeUrl(embedUrl, false);
    $[1] = embedUrl;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = title || "YouTube video";
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = <div className="mb-4"><div className="relative w-full" style={t1}><iframe src={t2} title={t3} className="absolute top-0 left-0 w-full h-full rounded" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true} /></div></div>;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};

// Share popup button for live-blog cards
const LiveBlogCardShare = t0 => {
  const $ = _c(19);
  const {
    slug,
    cardTitle
  } = t0;
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const popupRef = useRef(null);
  const articleUrl = `https://www.dinamani.com/${slug}`;
  const encodedUrl = encodeURIComponent(articleUrl);
  const encodedTitle = encodeURIComponent(cardTitle || "");
  let t1;
  let t2;
  if ($[0] !== open) {
    t1 = () => {
      if (!open) {
        return;
      }
      const handler = e => {
        if (popupRef.current && !popupRef.current.contains(e.target as Node)) {
          setOpen(false);
        }
      };
      document.addEventListener("mousedown", handler);
      return () => document.removeEventListener("mousedown", handler);
    };
    t2 = [open];
    $[0] = open;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== articleUrl) {
    t3 = async () => {
      try {
        await navigator.clipboard.writeText(articleUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch {}
    };
    $[3] = articleUrl;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleCopy = t3;
  let t4;
  if ($[5] !== open) {
    t4 = () => setOpen(!open);
    $[5] = open;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4"><circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" /><line x1="8.59" y1="13.51" x2="15.42" y2="17.49" /><line x1="15.41" y1="6.51" x2="8.59" y2="10.49" /></svg>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <button onClick={t4} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors text-4D4D4D" title={"\u0BAA\u0B95\u0BBF\u0BB0\u0BCD"}>{t5}</button>;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== copied || $[11] !== encodedTitle || $[12] !== encodedUrl || $[13] !== handleCopy || $[14] !== open) {
    t7 = open && <div className="absolute right-0 top-10 z-50 bg-white border border-DCDCDC rounded-lg shadow-lg p-3 flex flex-row gap-2 min-w-max"><a href={`https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedUrl}`} target="_blank" rel="noopener noreferrer" title="WhatsApp" className="bg-[#25D366] hover:bg-[#1da851] text-white w-8 h-8 rounded flex items-center justify-center transition-all hover:scale-110"><svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" /></svg></a><a href={`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`} target="_blank" rel="noopener noreferrer" title="X" className="bg-black hover:bg-gray-800 text-white w-8 h-8 rounded flex items-center justify-center transition-all hover:scale-110"><svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg></a><a href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`} target="_blank" rel="noopener noreferrer" title="Facebook" className="bg-[#1877F2] hover:bg-[#0d65d9] text-white w-8 h-8 rounded flex items-center justify-center transition-all hover:scale-110"><svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg></a><button onClick={handleCopy} title={copied ? "Copied!" : "Copy Link"} className={`${copied ? "bg-green-600" : "bg-[#128C7E]"} hover:bg-[#0d6e63] text-white w-8 h-8 rounded flex items-center justify-center transition-all hover:scale-110`}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" /><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" /></svg></button></div>;
    $[10] = copied;
    $[11] = encodedTitle;
    $[12] = encodedUrl;
    $[13] = handleCopy;
    $[14] = open;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <div className="relative" ref={popupRef}>{t6}{t7}</div>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};

/**
 * Update article schema in the DOM for SEO during infinite scroll
 * Updates BreadcrumbList and NewsArticle/LiveBlogPosting schemas with proper IDs
 */
function updateArticleSchema(story: any) {
  if (!story || typeof document === 'undefined') return;
  try {
    // Check if this is a live blog
    const isLiveBlog = story['story-template'] === 'live-blog' || story['is-live-blog'] === true;
    if (isLiveBlog) {
      // Generate LiveBlogPosting schema for live blogs
      const liveBlogSchema = generateLiveBlogPostingSchemaFromStory(story);
      const breadcrumbSchema = generateBreadcrumbSchemaFromStory(story);

      // Update BreadcrumbList schema
      let breadcrumbScript = document.getElementById('dinamani-breadcrumb-schema') as HTMLScriptElement | null;
      if (breadcrumbScript) {
        breadcrumbScript.textContent = JSON.stringify(breadcrumbSchema);
      } else {
        breadcrumbScript = document.createElement('script');
        breadcrumbScript.id = 'dinamani-breadcrumb-schema';
        breadcrumbScript.type = 'application/ld+json';
        breadcrumbScript.textContent = JSON.stringify(breadcrumbSchema);
        document.head.appendChild(breadcrumbScript);
      }

      // Update or create LiveBlogPosting schema
      let liveBlogScript = document.getElementById('dinamani-liveblog-schema') as HTMLScriptElement | null;
      if (liveBlogScript) {
        liveBlogScript.textContent = JSON.stringify(liveBlogSchema);
      } else {
        liveBlogScript = document.createElement('script');
        liveBlogScript.id = 'dinamani-liveblog-schema';
        liveBlogScript.type = 'application/ld+json';
        liveBlogScript.textContent = JSON.stringify(liveBlogSchema);
        document.head.appendChild(liveBlogScript);
      }

      // Remove NewsArticle schema if it exists (switching from regular article to live blog)
      const newsArticleScript = document.getElementById('dinamani-newsarticle-schema');
      if (newsArticleScript) {
        newsArticleScript.remove();
      }
    } else {
      // Regular article - use NewsArticle schema
      const schemas = generateArticleSchemaFromStory(story);
      const [breadcrumbSchema, newsArticleSchema] = schemas;

      // Update BreadcrumbList schema
      let breadcrumbScript = document.getElementById('dinamani-breadcrumb-schema') as HTMLScriptElement | null;
      if (breadcrumbScript) {
        breadcrumbScript.textContent = JSON.stringify(breadcrumbSchema);
      } else {
        breadcrumbScript = document.createElement('script');
        breadcrumbScript.id = 'dinamani-breadcrumb-schema';
        breadcrumbScript.type = 'application/ld+json';
        breadcrumbScript.textContent = JSON.stringify(breadcrumbSchema);
        document.head.appendChild(breadcrumbScript);
      }

      // Update NewsArticle schema
      let newsArticleScript = document.getElementById('dinamani-newsarticle-schema') as HTMLScriptElement | null;
      if (newsArticleScript) {
        newsArticleScript.textContent = JSON.stringify(newsArticleSchema);
      } else {
        newsArticleScript = document.createElement('script');
        newsArticleScript.id = 'dinamani-newsarticle-schema';
        newsArticleScript.type = 'application/ld+json';
        newsArticleScript.textContent = JSON.stringify(newsArticleSchema);
        document.head.appendChild(newsArticleScript);
      }

      // Remove LiveBlog schema if it exists (switching from live blog to regular article)
      const liveBlogScript = document.getElementById('dinamani-liveblog-schema');
      if (liveBlogScript) {
        liveBlogScript.remove();
      }
    }

    // Track GA page view for the new article
    if ((window as any).gtag) {
      (window as any).gtag('config', 'G-3M6WRBQKHL', {
        page_path: `/${story.slug}`,
        page_title: story.headline
      });
    }

    // Note: Do NOT call googletag.pubads().refresh() here.
    // Sidebar ads (ArticleMultiAds) manage their own lifecycle via unmount/remount.
    // Inline ads (ArticleAdSlot) use unique IDs per instance so they coexist.
  } catch (error) {}
}

/**
 * Generate a 6-character random alphanumeric code
 */
function generateUniqueCode(): string {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < 6; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

/**
 * Replace div IDs in ad code with unique IDs to prevent conflicts
 * when multiple articles render the same ad slots simultaneously in infinite scroll.
 */
function makeAdCodeUnique(code: string, uniqueCode: string): string {
  if (!code) return '';
  const foundIds = new Set<string>();

  // 1. Match div-gpt-ad IDs (standard GPT format)
  const gptPattern = /div-gpt-ad-[a-zA-Z0-9_.-]+/g;
  let match;
  while ((match = gptPattern.exec(code)) !== null) {
    foundIds.add(match[0]);
  }

  // 2. Match any id="..." attributes in HTML (catches non-standard div IDs)
  const idAttrPattern = /id\s*=\s*["']([^"']+)["']/g;
  while ((match = idAttrPattern.exec(code)) !== null) {
    foundIds.add(match[1]);
  }
  if (foundIds.size === 0) return code;
  let result = code;
  // Sort by length descending to avoid replacing substrings of longer IDs first
  const sortedIds = Array.from(foundIds).sort((a, b) => b.length - a.length);
  sortedIds.forEach(originalId => {
    const newId = `${originalId}-${uniqueCode}`;
    result = result.split(originalId).join(newId);
  });
  return result;
}

// Component to render article ad with dynamic div IDs
interface ArticleAdProps {
  adCode: string | null;
  adIndex: number;
  isRosInread?: boolean;
}
function ArticleAdSlot({
  adCode,
  adIndex,
  isRosInread
}: ArticleAdProps) {
  const adContainerRef = useRef<HTMLDivElement>(null);
  const hasInjectedRef = useRef(false);
  const slotDivIdRef = useRef<string | null>(null);

  // Unique code per instance so multiple articles in infinite scroll don't clash
  const uniqueCode = useMemo(() => generateUniqueCode(), []);
  useEffect(() => {
    if (!adCode || !adContainerRef.current || hasInjectedRef.current) return;
    hasInjectedRef.current = true;
    const container = adContainerRef.current;
    const cleaned = cleanAdCode(adCode);
    if (!cleaned) {
      return;
    }

    // Extract GPT slot parameters directly from the ad code instead of executing
    // the scripts (which have nested googletag.cmd.push that cause timing issues).
    const slotMatch = cleaned.match(/defineSlot\(\s*['"]([^'"]+)['"]\s*,\s*(\[[^\]]+\])\s*,\s*['"]([^'"]+)['"]\s*\)/);
    if (!slotMatch) {
      // Fallback: if we can't extract GPT params, use the old script execution approach
      const uniqueCode2 = makeAdCodeUnique(cleaned, `${uniqueCode}_${adIndex}`);
      const {
        html,
        scripts
      } = parseGptAdCode(uniqueCode2);
      container.innerHTML = `<div style="display:flex;justify-content:center;align-items:center;text-align:center;width:100%;">${html}</div>`;
      if (scripts.length > 0) {
        executeAdScripts(scripts);
      }
      return;
    }
    const [, slotPath, sizesStr, originalDivId] = slotMatch;
    let sizes: any;
    try {
      sizes = JSON.parse(sizesStr);
    } catch {
      sizes = [300, 250];
    }

    // On mobile, ensure mobile-friendly sizes are included so GPT can serve an ad
    // (desktop ad codes may only have large sizes like [728, 90] that won't fit)
    // Skip for ROS Inread — uses its own sizes from the ad code (desktop [1,1], mobile [300,250])
    if (!isRosInread && typeof window !== 'undefined' && window.innerWidth < 768) {
      const normalizedSizes: number[][] = Array.isArray(sizes[0]) ? sizes : [sizes];
      const hasSmallSize = normalizedSizes.some((s: number[]) => s[0] <= 336);
      if (!hasSmallSize) {
        sizes = [...normalizedSizes, [300, 250], [336, 280]];
      }
    }

    // Create a unique div ID for this instance
    const uniqueDivId = `${originalDivId}-${uniqueCode}-${adIndex}`;
    slotDivIdRef.current = uniqueDivId;

    // Create the ad container div (no min-width to avoid GPT blocking ads on narrow mobile screens)
    container.innerHTML = `<div id="${uniqueDivId}" style="width:100%;min-height:${Array.isArray(sizes[0]) ? sizes[0][1] : sizes[1] || 250}px;overflow:hidden;display:flex;justify-content:center;align-items:center;text-align:center;"></div>`;
    const divInDom = document.getElementById(uniqueDivId);

    // Use initGPT to ensure GPT is loaded, then define + display + refresh
    // all in a single cmd.push to avoid timing issues
    initGPT(() => {
      const googletag = (window as any).googletag;
      if (!googletag) {
        return;
      }
      googletag.cmd.push(() => {
        try {
          const slot = googletag.defineSlot(slotPath, sizes, uniqueDivId);
          if (slot) {
            slot.addService(googletag.pubads());
            googletag.enableServices();
            googletag.display(uniqueDivId);
            googletag.pubads().refresh([slot]);
          } else {}
        } catch (err) {
          console.error(`[ArticleAdSlot] ✗ Error in cmd.push:`, err);
        }
      });
    });
  }, [adCode, uniqueCode, adIndex]);

  // Cleanup: destroy GPT slots on unmount and reset injection flag
  useEffect(() => {
    return () => {
      const divId = slotDivIdRef.current;
      try {
        const googletag_0 = (window as any).googletag;
        if (googletag_0?.pubads && divId) {
          const allSlots = googletag_0.pubads()?.getSlots?.() || [];
          const slotsToDestroy = allSlots.filter((slot_0: any) => slot_0.getSlotElementId() === divId);
          if (slotsToDestroy.length > 0) {
            googletag_0.destroySlots(slotsToDestroy);
          }
        }
      } catch {/* ignore */}
      if (adContainerRef.current) {
        adContainerRef.current.innerHTML = '';
      }
      // Reset so re-mount can re-inject
      hasInjectedRef.current = false;
      slotDivIdRef.current = null;
    };
  }, []);
  if (!adCode) return null;

  // ROS Inread: no extra size/overflow constraints — render ad code as-is
  if (isRosInread) {
    return <div className="w-full my-4 flex justify-center">
        <div ref={adContainerRef} style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center" as const
      }} />
      </div>;
  }
  return <div className="w-full my-4 flex justify-center">
      <div className="bg-gray-100 p-[5px] relative overflow-hidden" style={{
      maxWidth: '336px'
    }}>
        <div ref={adContainerRef} style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center" as const,
        overflow: "hidden"
      }} />
        <AdvertisePopup />
      </div>
    </div>;
}

// Author names to hide from display
const HIDDEN_AUTHOR_NAMES = ['வணிகப் பெருக்கச் செய்தி'];

// Category/section names to hide from display
const HIDDEN_CATEGORY_NAMES = ['விளம்பரதாரர் செய்திகள்'];

/** Filter out hidden author names. Returns filtered array. */
function filterAuthors(authors: any[] | undefined): any[] {
  if (!authors) return [];
  return authors.filter((a: any) => !HIDDEN_AUTHOR_NAMES.includes(a?.name?.trim()));
}

/** Check if story has any visible authors */
function hasVisibleAuthors(story: any): boolean {
  return filterAuthors(story?.authors).length > 0;
}

// Component for inline article ads that cycles through ros-inread and multiple slots
interface InlineArticleAdProps {
  rosInreadAdCode: {
    desktopAdCode: string | null;
    mobileAdCode: string | null;
  };
  multipleAdSlots: Array<{
    desktopAdCode: string | null;
    mobileAdCode: string | null;
  }>;
  inlinePosition: number; // 0-indexed position of this inline ad
  adIndex: number;
}
function InlineArticleAd(t0) {
  const $ = _c(5);
  const {
    rosInreadAdCode,
    multipleAdSlots,
    inlinePosition,
    adIndex
  } = t0;
  const {
    isMobile,
    deviceDetected
  } = useDevice();
  if (!deviceDetected) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div style={{
        minHeight: "250px"
      }} />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let adCode;
  let adSource;
  if (inlinePosition === 0) {
    const ros = rosInreadAdCode;
    adCode = ros.desktopAdCode || null;
    adSource = "ros-inread";
  } else {
    if (multipleAdSlots.length > 0) {
      const slotIndex = inlinePosition - 1;
      if (slotIndex >= multipleAdSlots.length) {
        return null;
      }
      const slot = multipleAdSlots[slotIndex];
      adCode = isMobile ? slot?.mobileAdCode || slot?.desktopAdCode || null : slot?.desktopAdCode || null;
      adSource = `multiple-300x250[${slotIndex}]`;
    } else {
      const ros_0 = rosInreadAdCode;
      adCode = isMobile ? ros_0.mobileAdCode || ros_0.desktopAdCode || null : ros_0.desktopAdCode || null;
      adSource = "fallback-ros-inread";
    }
  }
  if (!adCode) {
    return null;
  }
  const t1 = adSource === "ros-inread" || adSource === "fallback-ros-inread";
  let t2;
  if ($[1] !== adCode || $[2] !== adIndex || $[3] !== t1) {
    t2 = <ArticleAdSlot adCode={adCode} adIndex={adIndex} isRosInread={t1} />;
    $[1] = adCode;
    $[2] = adIndex;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
interface ArticleListInfiniteProps {
  combinedArticles: any[];
  perArticleRelated: any[][];
  videos: any[];
  galleries?: any[];
  sectionSlug?: string; // Section slug for fetching more articles
}
export default function ArticleListInfinite({
  combinedArticles: initialArticles,
  perArticleRelated: initialPerArticleRelated,
  videos,
  galleries,
  sectionSlug
}: ArticleListInfiniteProps) {
  // State for articles - allows live-blog refresh updates and infinite scroll additions
  const [combinedArticles, setCombinedArticles] = useState(initialArticles);
  const [perArticleRelated, setPerArticleRelated] = useState(initialPerArticleRelated);
  const [visibleCount, setVisibleCount] = useState(1);
  const [currentArticleIndex, setCurrentArticleIndex] = useState(0); // For single mode navigation
  const currentArticleIndexRef = useRef(0); // Use ref to avoid re-renders on scroll
  const [activeAdArticleIndex, setActiveAdArticleIndex] = useState(0); // Track which article shows sidebar ads
  const sentinelRef = useRef<HTMLDivElement | null>(null);
  const articleRefs = useRef<(HTMLDivElement | null)[]>([]);
  const isLoadingMore = useRef(false); // Track when we're loading more articles
  const combinedArticlesRef = useRef(combinedArticles); // Ref to access current articles in observer

  // Pagination state for fetching more articles
  const [hasMoreArticles, setHasMoreArticles] = useState(true);
  const fetchOffsetRef = useRef(1); // Start from 1 since we already have the first article
  const loadedSlugsRef = useRef<Set<string>>(new Set(initialArticles.map(a => a.story?.slug).filter(Boolean)));

  // Keep ref updated with latest combinedArticles
  useEffect(() => {
    combinedArticlesRef.current = combinedArticles;
  }, [combinedArticles]);

  // Mark infinite scroll as active so that cosmetic URL updates (history.replaceState)
  // don't trigger destroyAllSlots() in other ad components (StickyAds, SmartLayoutAds).
  // Inline ads use unique IDs and manage their own cleanup on unmount.
  useEffect(() => {
    setInfiniteScrollActive(true);
    return () => setInfiniteScrollActive(false);
  }, []);

  // Prefetch next batch of articles on mount for faster infinite scroll
  const hasPrefetchedRef = useRef(false);
  useEffect(() => {
    if (hasPrefetchedRef.current || !sectionSlug || !hasMoreArticles) return;
    hasPrefetchedRef.current = true;

    // Delay prefetch slightly to not compete with initial render
    const timer = setTimeout(async () => {
      if (isLoadingMore.current) return;
      isLoadingMore.current = true;
      const prefetchUrl = `/api/articles?sectionSlug=${encodeURIComponent(sectionSlug)}&offset=${fetchOffsetRef.current}&limit=5`;
      const fullPrefetchUrl = `${window.location.origin}${prefetchUrl}`;
      const prefetchStart = Date.now();
      try {
        const response = await fetch(prefetchUrl);
        const elapsed = Date.now() - prefetchStart;

        // Log response headers for debugging proxy/CORS issues
        const contentType = response.headers.get('content-type');
        const corsHeader = response.headers.get('access-control-allow-origin');
        if (!response.ok) {
          const errorBody = await response.text().catch(() => 'could not read body');
          console.error(`[InfiniteScroll] PREFETCH API ERROR: HTTP ${response.status} ${response.statusText}, url="${response.url}", body="${errorBody.substring(0, 500)}"`);
          return;
        }

        // Try to parse response as JSON
        const responseText = await response.text();
        let data: any;
        try {
          data = JSON.parse(responseText);
        } catch (parseErr) {
          console.error(`[InfiniteScroll] PREFETCH JSON PARSE ERROR: response is not valid JSON, body="${responseText.substring(0, 500)}", url="${response.url}"`);
          return;
        }

        // Check for error in response body
        if (data.error) {
          console.error(`[InfiniteScroll] PREFETCH API ERROR IN BODY: error="${data.error}", message="${data.message || ''}", url="${response.url}"`);
          return;
        }
        if (data.articles && data.articles.length > 0) {
          const indicesToKeep: number[] = [];
          const newArticles = data.articles.filter((article: any, index: number) => {
            const isNew = article.story?.slug && !loadedSlugsRef.current.has(article.story.slug);
            if (isNew) indicesToKeep.push(index);
            return isNew;
          });
          if (newArticles.length > 0) {
            newArticles.forEach((article: any) => {
              if (article.story?.slug) {
                loadedSlugsRef.current.add(article.story.slug);
              }
            });
            setCombinedArticles(prev => [...prev, ...newArticles]);
            const newRelatedStories = indicesToKeep.map(index => data.relatedStories?.[index] || []);
            setPerArticleRelated(prev => [...prev, ...newRelatedStories]);
            fetchOffsetRef.current += data.articles.length;
          }
        } else {
          console.error(`[InfiniteScroll] PREFETCH EMPTY: API returned 0 articles, hasMore=${data.hasMore}, total=${data.total ?? '?'}, fullResponse=${responseText.substring(0, 300)}`);
        }
        setHasMoreArticles(data.hasMore);
      } catch (err: any) {
        const elapsed = Date.now() - prefetchStart;
        console.error(`[InfiniteScroll] PREFETCH NETWORK ERROR: ${err?.name || 'Error'}: ${err?.message || err}, type=${err?.name}, url="${fullPrefetchUrl}" (${elapsed}ms)`);
        if (err?.name === 'TypeError') {
          console.error(`[InfiniteScroll] PREFETCH CORS/NETWORK: TypeError usually means CORS blocked or network failure. Check if the server URL is accessible from the browser.`);
        }
      } finally {
        isLoadingMore.current = false;
      }
    }, 500); // Small delay after initial render

    return () => clearTimeout(timer);
  }, [sectionSlug, hasMoreArticles]);

  // Live blog auto-update every 10 seconds
  const liveBlogSlugRef = useRef<string | null>(null);

  // Check if this is a live blog
  const firstStory = initialArticles[0]?.story;
  const isLiveBlog = firstStory?.['story-template'] === 'live-blog' || firstStory?.['is-live-blog'] === true;
  const storySlug = firstStory?.slug;
  useEffect(() => {
    if (!isLiveBlog || !storySlug) {
      return;
    }
    liveBlogSlugRef.current = storySlug;
    const updateLiveBlog = async () => {
      const slug = liveBlogSlugRef.current;
      if (!slug) return;
      const liveBlogUrl = `/api/articles?slug=${encodeURIComponent(slug)}&liveblog=true`;
      const liveBlogStart = Date.now();
      try {
        const response = await fetch(liveBlogUrl, {
          cache: 'no-store'
        });
        if (!response.ok) {
          return;
        }
        const data = await response.json();
        const newCards = data?.story?.cards;
        if (!newCards) {
          return;
        }

        // Use ref to get current state for comparison (avoiding closure issues)
        const currentStory = combinedArticlesRef.current[0]?.story;
        const currentCards = currentStory?.cards || [];

        // Check for any changes
        const hasCardCountChange = newCards.length !== currentCards.length;
        const hasStoryUpdate = data.story['content-updated-at'] !== currentStory?.['content-updated-at'] || data.story['last-published-at'] !== currentStory?.['last-published-at'];

        // Check if ANY card has been updated by comparing all card timestamps
        let hasCardUpdate = false;
        for (let i = 0; i < newCards.length; i++) {
          const newCard = newCards[i];
          const currentCard = currentCards[i];
          if (!currentCard || newCard?.['card-updated-at'] !== currentCard?.['card-updated-at'] || newCard?.['card-added-at'] !== currentCard?.['card-added-at'] || newCard?.id !== currentCard?.id) {
            hasCardUpdate = true;
            break;
          }
        }
        const hasChanges = hasCardCountChange || hasCardUpdate || hasStoryUpdate;
        if (!hasChanges) {
          return;
        }

        // Update state
        setCombinedArticles(prev => {
          const updated = [...prev];
          updated[0] = {
            ...updated[0],
            story: {
              ...updated[0].story,
              ...data.story,
              cards: newCards
            }
          };
          return updated;
        });

        // Update LiveBlogPosting schema for SEO
        updateArticleSchema(data.story);
      } catch {
        // LiveBlog update error - silently ignore
      }
    };

    // First fetch
    updateLiveBlog();

    // Setup interval
    const intervalId = setInterval(() => {
      updateLiveBlog();
    }, LIVE_BLOG_REFRESH_INTERVAL);
    return () => {
      clearInterval(intervalId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLiveBlog, storySlug]);

  // Disable browser's automatic scroll restoration
  useEffect(() => {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    return () => {
      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'auto';
      }
    };
  }, []);

  // Track which paragraph index we're at for inline ads (to determine ros-inread vs multiple slots)
  const inlineAdCounterRef = useRef<number>(0);

  // Website settings
  const showAudioPlayer = useBooleanSetting('show-article-audio-player');
  const showPublishedOn = useBooleanSetting('show-article-published-on');
  const articleInfiniteScroll = useBooleanSetting('article-infinite-scroll');
  const noInfiniteArticle = useStringSetting('no-infinite-article');
  const needArticlePromotionHtml = useBooleanSetting('need-article-promotion-html');
  const articlePromotionHtml = useStringSetting('article-promotion-html');

  // Read ad settings from context (embedded in HTML, zero HTTP calls)
  const adSlotAfterParagraphSetting = useWebsiteSetting('ad-slot-after-paragraph');
  const articleAdSlot = useAdSlot('article-ad');
  const articlePageStyleSetting = useWebsiteSetting('article-page-style');
  const rosInreadSlot = useAdSlot(ARTICLE_AD_SLOT_NAMES.ROS_INREAD);
  const multipleAdSlot = useAdSlot(ARTICLE_AD_SLOT_NAMES.MULTIPLE_300X250);
  const adSlotInterval = useMemo(() => {
    const val = adSlotAfterParagraphSetting?.value;
    return val ? Number(val) || 3 : 3;
  }, [adSlotAfterParagraphSetting]);
  const articleAdCode = articleAdSlot?.desktopAdCode || null;
  const articlePageStyle: 'infinite' | 'single' = useMemo(() => {
    return articlePageStyleSetting?.value === 'single' ? 'single' : 'infinite';
  }, [articlePageStyleSetting]);
  const rosInreadAdCode = useMemo(() => ({
    desktopAdCode: rosInreadSlot?.desktopAdCode || null,
    mobileAdCode: rosInreadSlot?.mobileAdCode || null
  }), [rosInreadSlot]);
  const multipleAdSlots = useMemo(() => {
    if (multipleAdSlot?.isMultiple && multipleAdSlot?.slots) {
      return multipleAdSlot.slots;
    }
    return [];
  }, [multipleAdSlot]);

  // Determine max articles for infinite scroll
  const maxArticles = articleInfiniteScroll && noInfiniteArticle ? parseInt(noInfiniteArticle, 10) || combinedArticles.length : combinedArticles.length;

  // Navigation functions for single mode
  const goToPreviousArticle = useCallback(() => {
    if (currentArticleIndex > 0) {
      const newIndex = currentArticleIndex - 1;
      setCurrentArticleIndex(newIndex);
      setActiveAdArticleIndex(newIndex);
      // Update URL
      const story = combinedArticles[newIndex]?.story;
      if (story?.slug) {
        window.history.replaceState({
          articleIndex: newIndex,
          slug: story.slug
        }, '', `/${story.slug}`);
        document.title = `${story.headline} - தினமணி`;
        // Update schema markup for the new article (SEO)
        updateArticleSchema(story);
      }
      // Scroll to top
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [currentArticleIndex, combinedArticles]);
  const goToNextArticle = useCallback(() => {
    if (currentArticleIndex < combinedArticles.length - 1) {
      const newIndex = currentArticleIndex + 1;
      setCurrentArticleIndex(newIndex);
      setActiveAdArticleIndex(newIndex);
      // Update URL
      const story = combinedArticles[newIndex]?.story;
      if (story?.slug) {
        window.history.replaceState({
          articleIndex: newIndex,
          slug: story.slug
        }, '', `/${story.slug}`);
        document.title = `${story.headline} - தினமணி`;
        // Update schema markup for the new article (SEO)
        updateArticleSchema(story);
      }
      // Scroll to top
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [currentArticleIndex, combinedArticles]);

  // Whether we have any inline ad codes available
  const hasInlineAdCodes = !!(rosInreadAdCode.desktopAdCode || rosInreadAdCode.mobileAdCode) || multipleAdSlots.length > 0;

  // Helper to split HTML text into top-level block elements (<p>, <ul>, <ol>, <div>, <blockquote>, <h1>-<h6>, <table>)
  // Preserves <ul>/<ol> as single blocks so list structure (bullet points) is not broken
  const splitIntoParagraphs = (html: string): string[] => {
    if (!html) return [];
    const matches = html.match(/<(p|ul|ol|div|blockquote|h[1-6]|table)[\s\S]*?<\/\1>/gi);
    return matches || [];
  };

  // Pre-compute paragraph map for a story (paragraph-based ad insertion)
  // Returns: map of "cardIdx_elementIdx" -> { startIndex, paragraphs }
  const computeParagraphMap = (story: any): Record<string, {
    startIndex: number;
    paragraphs: string[];
  }> => {
    const map: Record<string, {
      startIndex: number;
      paragraphs: string[];
    }> = {};
    let globalParaIdx = 0;
    for (let cardIdx = 0; cardIdx < (story.cards?.length || 0); cardIdx++) {
      const card = story.cards[cardIdx];
      for (let elemIdx = 0; elemIdx < (card['story-elements']?.length || 0); elemIdx++) {
        const element = card['story-elements'][elemIdx];
        // Only count regular text elements (not summary, also-read, or promotional)
        if (element.type === 'text' && element.text && element.subtype !== 'summary' && element.subtype !== 'also-read' && !element.metadata?.['promotional-message']) {
          const paragraphs = splitIntoParagraphs(element.text);
          if (paragraphs.length > 0) {
            map[`${cardIdx}_${elemIdx}`] = {
              startIndex: globalParaIdx,
              paragraphs
            };
            globalParaIdx += paragraphs.length;
          }
        }
      }
    }
    return map;
  };

  // Check if ad should show after this paragraph (0-indexed global paragraph index)
  // First ad (ROS inread): after 2nd paragraph (index 1)
  // Subsequent ads: after every N paragraphs from the first ad
  const shouldShowAdAfterParagraph = (globalParaIdx: number): boolean => {
    // First ad: after 2nd paragraph
    if (globalParaIdx === 1) return true;
    // Subsequent ads based on adSlotInterval
    if (globalParaIdx > 1 && adSlotInterval > 0) {
      return (globalParaIdx - 1) % adSlotInterval === 0;
    }
    return false;
  };

  // Get ad position for paragraph (0 = ROS inread, 1+ = multiple 300x250 cycling)
  const getAdPositionForParagraph = (globalParaIdx: number): number => {
    if (globalParaIdx <= 1) return 0; // ROS inread
    if (adSlotInterval <= 0) return 0;
    return Math.floor((globalParaIdx - 1) / adSlotInterval);
  };

  // Legacy helpers for non-text templates (story-element based counting)
  const getGlobalElementIndex = (story: any, cardIdx: number, elementIdx: number): number => {
    let globalIndex = 0;
    for (let i = 0; i < cardIdx; i++) {
      globalIndex += story.cards?.[i]?.['story-elements']?.length || 0;
    }
    return globalIndex + elementIdx;
  };
  const shouldShowInlineAd = (story: any, cardIdx: number, elementIdx: number): boolean => {
    if (adSlotInterval <= 0) return false;
    const globalIndex = getGlobalElementIndex(story, cardIdx, elementIdx);
    return (globalIndex + 1) % adSlotInterval === 0;
  };
  const getInlineAdPosition = (story: any, cardIdx: number, elementIdx: number): number => {
    if (adSlotInterval <= 0) return 0;
    const globalIndex = getGlobalElementIndex(story, cardIdx, elementIdx);
    return Math.floor((globalIndex + 1) / adSlotInterval) - 1;
  };

  // Gallery-specific helpers: only count text elements for ad placement
  // (prevents ads from stacking between images on photo/photo-visual pages)
  const isTextStoryElement = (element: any): boolean => {
    return element?.type === 'text' && !!element?.text && element?.subtype !== 'summary' && !element?.metadata?.['promotional-message'];
  };
  const getGlobalTextElementCount = (story: any, cardIdx: number, elementIdx: number): number => {
    let textCount = 0;
    for (let i = 0; i <= cardIdx; i++) {
      const elements = story.cards?.[i]?.['story-elements'] || [];
      const maxJ = i === cardIdx ? elementIdx : elements.length - 1;
      for (let j = 0; j <= maxJ; j++) {
        if (isTextStoryElement(elements[j])) {
          textCount++;
        }
      }
    }
    return textCount;
  };
  const shouldShowGalleryInlineAd = (story: any, cardIdx: number, elementIdx: number): boolean => {
    const globalIndex = getGlobalElementIndex(story, cardIdx, elementIdx);

    // ROS Inread (video ad): always show after the 2nd element regardless of type
    if (globalIndex === 1) return true;

    // Subsequent ads: only show after text elements
    const element = story.cards?.[cardIdx]?.['story-elements']?.[elementIdx];
    if (!isTextStoryElement(element)) return false;
    if (adSlotInterval <= 0) return false;
    const textCount = getGlobalTextElementCount(story, cardIdx, elementIdx);
    return textCount > 0 && textCount % adSlotInterval === 0;
  };
  const getGalleryInlineAdPosition = (story: any, cardIdx: number, elementIdx: number): number => {
    const globalIndex = getGlobalElementIndex(story, cardIdx, elementIdx);

    // ROS Inread (video ad): position 0
    if (globalIndex <= 1) return 0;

    // Subsequent ads: position 1+ based on text element count
    if (adSlotInterval <= 0) return 0;
    const textCount = getGlobalTextElementCount(story, cardIdx, elementIdx);
    return Math.floor(textCount / adSlotInterval);
  };
  const cardHasTextContent = (card: any): boolean => {
    return card?.['story-elements']?.some((el: any) => isTextStoryElement(el)) || false;
  };
  const loadMore = useCallback(async () => {
    // Prevent multiple simultaneous loads
    if (isLoadingMore.current) {
      return;
    }

    // Check if we already have buffered articles to show
    const bufferedCount = combinedArticles.length - visibleCount;

    // If we have buffered articles, show the next one immediately
    if (bufferedCount > 0) {
      const nextSlug = combinedArticles[visibleCount]?.story?.slug || 'unknown';
      setVisibleCount(prev => Math.min(prev + 1, combinedArticles.length));

      // If buffer is running low (less than 3), trigger a background fetch
      if (bufferedCount < 3 && hasMoreArticles && sectionSlug) {
        // Don't await - let it fetch in background
        fetchMoreArticles();
      }
      return;
    }

    // No buffered articles - need to fetch and wait
    if (!hasMoreArticles || !sectionSlug) {
      return;
    }
    await fetchMoreArticles();
  }, [hasMoreArticles, sectionSlug, combinedArticles.length, visibleCount]);

  // Separate function for fetching articles (can be called in background)
  const fetchMoreArticles = useCallback(async () => {
    if (isLoadingMore.current || !hasMoreArticles || !sectionSlug) {
      return;
    }
    isLoadingMore.current = true;
    const fetchUrl = `/api/articles?sectionSlug=${encodeURIComponent(sectionSlug)}&offset=${fetchOffsetRef.current}&limit=5`;
    const fullFetchUrl = `${window.location.origin}${fetchUrl}`;
    const fetchStart = Date.now();
    try {
      const response = await fetch(fetchUrl);
      const elapsed = Date.now() - fetchStart;

      // Log response headers for debugging proxy/CORS issues
      const contentType = response.headers.get('content-type');
      const corsHeader = response.headers.get('access-control-allow-origin');
      if (!response.ok) {
        const errorBody = await response.text().catch(() => 'could not read body');
        console.error(`[InfiniteScroll] FETCH_MORE API ERROR: HTTP ${response.status} ${response.statusText}, url="${response.url}", body="${errorBody.substring(0, 500)}"`);
        return;
      }

      // Try to parse response as JSON
      const responseText = await response.text();
      let data: any;
      try {
        data = JSON.parse(responseText);
      } catch (parseErr) {
        console.error(`[InfiniteScroll] FETCH_MORE JSON PARSE ERROR: response is not valid JSON, body="${responseText.substring(0, 500)}", url="${response.url}"`);
        return;
      }

      // Check for error in response body
      if (data.error) {
        console.error(`[InfiniteScroll] FETCH_MORE API ERROR IN BODY: error="${data.error}", message="${data.message || ''}", url="${response.url}"`);
        return;
      }
      if (data.articles && data.articles.length > 0) {
        const indicesToKeep: number[] = [];
        const newArticles = data.articles.filter((article: any, index: number) => {
          const isNew = article.story?.slug && !loadedSlugsRef.current.has(article.story.slug);
          if (isNew) indicesToKeep.push(index);
          return isNew;
        });
        if (newArticles.length > 0) {
          newArticles.forEach((article: any) => {
            if (article.story?.slug) {
              loadedSlugsRef.current.add(article.story.slug);
            }
          });
          setCombinedArticles(prev => [...prev, ...newArticles]);
          const newRelatedStories = indicesToKeep.map(index => data.relatedStories?.[index] || []);
          setPerArticleRelated(prev => [...prev, ...newRelatedStories]);
          setVisibleCount(prev => {
            const buffered = combinedArticles.length + newArticles.length - prev;
            if (buffered === newArticles.length) {
              return prev + 1;
            }
            return prev;
          });
        }
        fetchOffsetRef.current += data.articles.length;
      } else {
        console.error(`[InfiniteScroll] FETCH_MORE EMPTY: API returned 0 articles, hasMore=${data.hasMore}, total=${data.total ?? '?'}, fullResponse=${responseText.substring(0, 300)}`);
      }
      setHasMoreArticles(data.hasMore);
    } catch (err: any) {
      const elapsed = Date.now() - fetchStart;
      console.error(`[InfiniteScroll] FETCH_MORE NETWORK ERROR: ${err?.name || 'Error'}: ${err?.message || err}, type=${err?.name}, url="${fullFetchUrl}" (${elapsed}ms)`);
      if (err?.name === 'TypeError') {
        console.error(`[InfiniteScroll] FETCH_MORE CORS/NETWORK: TypeError usually means CORS blocked or network failure. Check if the server URL is accessible from the browser.`);
      }
    } finally {
      isLoadingMore.current = false;
    }
  }, [hasMoreArticles, sectionSlug, combinedArticles.length]);

  // Infinite scroll observer ref
  const observerRef = useRef<IntersectionObserver | null>(null);

  // Callback ref for sentinel - ensures observer attaches when element mounts
  const setSentinelRef = useCallback((node: HTMLDivElement | null) => {
    // Disconnect from previous element
    if (sentinelRef.current && observerRef.current) {
      observerRef.current.unobserve(sentinelRef.current);
    }
    sentinelRef.current = node;

    // Connect to new element if conditions are met
    if (node && articlePageStyle === 'infinite' && observerRef.current) {
      observerRef.current.observe(node);
    } else if (node) {}
  }, [articlePageStyle]);

  // Infinite scroll observer - loads more articles when sentinel is visible (only in infinite mode)
  useEffect(() => {
    if (articlePageStyle !== 'infinite') {
      // Clean up observer if not in infinite mode
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
      return;
    }

    // Create observer - use large rootMargin to trigger prefetching early
    observerRef.current = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        loadMore();
      }
    }, {
      root: null,
      rootMargin: '800px',
      // Trigger 800px before reaching sentinel for early prefetch
      threshold: 0
    });

    // Observe sentinel if it already exists
    if (sentinelRef.current) {
      observerRef.current.observe(sentinelRef.current);
    } else {}
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
    };
  }, [loadMore, articlePageStyle]);
  const visibleArticles = combinedArticles.slice(0, Math.min(visibleCount, maxArticles));

  // Persistent observer ref for URL updates
  const urlObserverRef = useRef<IntersectionObserver | null>(null);
  const observedElementsRef = useRef<Set<Element>>(new Set());

  // Create observer once on mount (only for infinite mode - URL updates on scroll)
  useEffect(() => {
    // Skip URL observer in single mode - URL is updated via navigation arrows
    if (articlePageStyle === 'single') return;
    const observerOptions = {
      root: null,
      rootMargin: '-50% 0px -50% 0px',
      // Trigger when article crosses the middle of viewport
      threshold: 0
    };
    urlObserverRef.current = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const index = articleRefs.current.findIndex(ref => ref === entry.target);
          if (index !== -1 && index !== currentArticleIndexRef.current) {
            const prevIndex = currentArticleIndexRef.current;
            currentArticleIndexRef.current = index;
            // Update sidebar ads to show for the new active article
            setActiveAdArticleIndex(index);
            // Update URL when scrolling to a different article
            const currentStory = combinedArticlesRef.current[index]?.story;
            if (currentStory?.slug) {
              const newUrl = `/${currentStory.slug}`;

              // Set flag to prevent ScrollToTop from scrolling to top
              (window as any).__skipScrollToTop = true;
              window.history.replaceState({
                articleIndex: index,
                slug: currentStory.slug
              }, '', newUrl);
              document.title = `${currentStory.headline} - தினமணி`;

              // Update schema markup for the new article (SEO)
              updateArticleSchema(currentStory);
            }
          }
        }
      });
    }, observerOptions);
    return () => {
      urlObserverRef.current?.disconnect();
      observedElementsRef.current.clear();
    };
  }, [articlePageStyle]);

  // Observe new article elements when they're added (only for infinite mode)
  useEffect(() => {
    if (!urlObserverRef.current || articlePageStyle === 'single') return;
    articleRefs.current.forEach(ref => {
      if (ref && !observedElementsRef.current.has(ref)) {
        urlObserverRef.current!.observe(ref);
        observedElementsRef.current.add(ref);
      }
    });
  }, [visibleArticles.length, articlePageStyle]);

  // For single mode, show only the current article
  const articlesToShow = articlePageStyle === 'single' ? [combinedArticles[currentArticleIndex]].filter(Boolean) : visibleArticles;

  // State for portal mounting
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);

  // Navigation arrows component for single mode - rendered via portal to body for true fixed positioning
  const NavigationArrows = () => {
    if (!isMounted) return null;
    const isFirstArticle = currentArticleIndex === 0;
    const isLastArticle = currentArticleIndex >= combinedArticles.length - 1;
    return createPortal(<>
        {/* Left Arrow - Fixed at browser left center (disabled on first article) */}
        <button onClick={goToPreviousArticle} disabled={isFirstArticle} className={`fixed left-0 top-1/2 -translate-y-1/2 z-[9999] flex items-center justify-center w-6 h-12 lg:w-10 lg:h-20 rounded-r-md border border-gray-300 transition-all ${isFirstArticle ? 'bg-gray-200 text-gray-400 cursor-not-allowed shadow-md' : 'bg-white text-012061 hover:bg-012061 hover:text-white cursor-pointer shadow-lg'}`} aria-label="Previous article">
          <ChevronLeftIcon className="w-5 h-5 lg:w-7 lg:h-7" />
        </button>

        {/* Right Arrow - Fixed at browser right center (disabled on last article) */}
        <button onClick={goToNextArticle} disabled={isLastArticle} className={`fixed right-0 top-1/2 -translate-y-1/2 z-[9999] flex items-center justify-center w-6 h-12 lg:w-10 lg:h-20 rounded-l-md border border-gray-300 transition-all ${isLastArticle ? 'bg-gray-200 text-gray-400 cursor-not-allowed shadow-md' : 'bg-white text-012061 hover:bg-012061 hover:text-white cursor-pointer shadow-lg'}`} aria-label="Next article">
          <ChevronRightIcon className="w-5 h-5 lg:w-7 lg:h-7" />
        </button>
      </>, document.body);
  };
  return <div className="flex flex-col" onCopy={e => e.preventDefault()} onCut={e => e.preventDefault()} onContextMenu={e => e.preventDefault()} style={{
    userSelect: 'none',
    WebkitUserSelect: 'none'
  }}>
      {articlesToShow.map((article: any, index: number) => {
      // For single mode, use currentArticleIndex for related stories
      const actualIndex = articlePageStyle === 'single' ? currentArticleIndex : index;
      const {
        story
      } = article;
      const articleRelated = perArticleRelated[actualIndex] || [];
      const rawCategory = (story.sections?.[0]?.name || 'INDIA').trim();
      const category = HIDDEN_CATEGORY_NAMES.includes(rawCategory) ? '' : rawCategory;
      // Remove domain from section-url (handles http/https, www, trailing slash)
      const sectionUrl = story.sections?.[0]?.['section-url'] ? story.sections[0]['section-url'].replace(/^https?:\/\/(www\.)?dinamani\.com\/?/, '/') : '';
      const imageUrl = story['hero-image-s3-key'] ? getImageUrl(story['hero-image-s3-key']) : '';
      const imageAttribution = story['hero-image-attribution'] || '';
      const publishedAt = formatTimeAgo(story['published-at']);
      const updatedAt = formatTimeAgo(story['last-published-at']);
      const articleContent = extractTextFromCards(story.cards);
      const tagNames = story.tags?.map((tag: any) => ({
        name: tag.name,
        slug: tag.slug
      }));

      // Collect linked-story-ids already rendered inline as also-read elements
      const inlineAlsoReadIds = new Set<string>();
      story.cards?.forEach((card: any) => {
        card['story-elements']?.forEach((el: any) => {
          if (el.subtype === 'also-read') {
            const id = el.metadata?.['linked-story-id'] || el['linked-story-id'];
            if (id) inlineAlsoReadIds.add(id);
          }
        });
      });

      // Common Footer Component
      const ArticleFooter = () => <>
            {/* <div className="border-b border-DCDCDC">
              <SocialMediaButtons
                socialMediaData={[
                  { text: 'Facebook', href: SOCIAL_MEDIA_LINKS.FACEBOOK },
                  { text: 'Twitter', href: SOCIAL_MEDIA_LINKS.TWITTER },
                  { text: 'Instagram', href: SOCIAL_MEDIA_LINKS.INSTAGRAM },
                  { text: 'YouTube', href: SOCIAL_MEDIA_LINKS.YOUTUBE },
                ]}
              />
             </div> */}
            {/* <div className="border-b border-DCDCDC"><OnesideText text={'தொடர்புடைய குறிச்சொற்கள்'} /></div> */}
            {tagNames && tagNames.length > 0 && <div className="border-b border-DCDCDC"><ChipsForm chips={tagNames} /></div>}
            {/* Mount Vuukle for prev/current/next so the iframe preloads in the background, but only show the active article's comments */}
            {/* {Math.abs(index - activeAdArticleIndex) <= 1 && (
              <div style={{ display: index === activeAdArticleIndex ? 'block' : 'none' }} aria-hidden={index !== activeAdArticleIndex}>
                <p style={{ fontSize: '12px', color: '#666', lineHeight: 1.6, padding: '12px', background: '#f9f9f9', borderRadius: '6px', borderLeft: '3px solid #012061', margin: '12px 16px' }}>பின்னூட்டத்தில் வெளியாகும் கருத்துகளுக்கு அவற்றைப் பதிவிடுவோரே முழுப் பொறுப்பு; அவை தினமணியின் கருத்துகளைப் பிரதிபலிக்கவில்லை.தனிநபர், சமூகம், மதம் அல்லது நாடு ஆகியவற்றுக்கு எதிராக அவமதிக்கிற அல்லது ஆபாசமான விதத்திலுள்ள எந்தவொரு கருத்தும் இந்திய அரசின் தகவல் தொழில்நுட்பக் கொள்கைப்படி தண்டனைக்குரிய குற்றம். இதுபோன்ற கருத்துகளுக்கு எதிராக உரிய சட்ட நடவடிக்கை எடுக்கப்படும்.</p>
                 <div className="border-b border-DCDCDC p-4">
                  <VuukleWidgets
                    key={`vuukle-${story.id}`}
                    articleId={story.id}
                    articleTitle={story.headline || ''}
                    articleUrl={`https://www.dinamani.com/${story.slug}`}
                    articleImage={imageUrl}
                    articleTags={story.tags?.slice(0, 3).map((tag: any) => tag.name).join(',') || category}
                    articleAuthor={story.authors?.[0]?.name || 'Dinamani'}
                  />
                </div>
              </div>
             )} */}

            {/* Infinite ad moved out of the footer — rendered full-width
                below the row, with related stories + videos beneath it. */}

            {/* <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3 sm:gap-5 p-3 sm:p-4 border-b border-DCDCDC">
              <p className="text-12-tamil-700 text-020202">ஒரு இடுகையைப் பகிரவும்</p>
              <SocialIcons />
             </div> */}
            {/* <div className="border-b border-DCDCDC"><OnesideText text={'எதிர்வினைகள்'} /></div>
             <div className="border-b border-DCDCDC">
              <EmojiRating />
             </div>
             <div className="border-b border-DCDCDC"><OnesideText text={'உங்கள் கருத்துக்கள்'} /></div>
             <div className="">
              <HorizontalCommentsNews />
             </div>
             <div className="flex justify-center p-4">
              <Button variant="outline" className="cursor-pointer ">
                மேலும் கருத்துகளை ஏற்றவும்
              </Button>
             </div>
             <Form /> */}
            {/* <div className="flex justify-center p-4 overflow-hidden">
              <Ad unit={AD_UNITS.DSK_STICKY} />
             </div> */}

            {/* {(index < visibleArticles.length - 1 || visibleCount < maxArticles) && (
              <Divider />
             )} */}
          </>;

      // Promotion HTML block — rendered in Shadow DOM for full style isolation
      const promotionBlock = needArticlePromotionHtml && articlePromotionHtml ? <div className="border-b border-DCDCDC">
            <ShadowDomHtml html={articlePromotionHtml} />
          </div> : null;
      return <div key={index} ref={el => {
        articleRefs.current[index] = el;
      }} className="w-full border-b border-DCDCDC">
            <div className="flex flex-col lg:flex-row">
              {/* Left: article body (70%) */}
              <div className="w-full lg:w-[70%]">
                {/* Mobile-only ad at top of article - only render for active article */}
                <div className="block lg:hidden border-b border-DCDCDC article-page-first-ad-mobile">
                  {index === activeAdArticleIndex && <ArticleMultiAds key={`first-ad-mobile-${index}`} position="first-ad-mobile" />}
                </div>
                {(story['story-template'] === 'text' || story['story-template'] === 'syndicated') && <>
                    <div className="border-b border-DCDCDC">
                      <BigNewsWithicon category={category} sectionUrl={sectionUrl} title={story.headline} excerpt={story.subheadline || story.summary} imageSrc={imageUrl} imageCaption={story['hero-image-caption']} imageAttribution={imageAttribution} imageMetadata={story['hero-image-metadata']} publishedAt={publishedAt} updatedAt={updatedAt} showPublished={showPublishedOn} slug={story.slug} articleUrl={`/${story.slug}`} />
                    </div>
                    {promotionBlock}
                    {showAudioPlayer && <AudioPlayer />}
                    {/* Story-level embed-js (video/tweet/instagram embed at story level) */}
                    {story['embed-js'] && <div className="border-b border-DCDCDC p-4">
                        {(() => {
                  // Decode base64 and check embed type
                  try {
                    const decoded = atob(story['embed-js']);
                    if (decoded.includes('twitter-tweet') || decoded.includes('platform.twitter.com')) {
                      return <TweetEmbed embedJs={story['embed-js']} />;
                    }
                    if (decoded.includes('instagram-media') || decoded.includes('instagram.com')) {
                      return <InstagramEmbed embedJs={story['embed-js']} />;
                    }
                  } catch {
                    // Not base64 or decode failed, check raw content
                    if (story['embed-js'].includes('twitter-tweet') || story['embed-js'].includes('platform.twitter.com')) {
                      return <TweetEmbed embedJs={story['embed-js']} />;
                    }
                    if (story['embed-js'].includes('instagram-media') || story['embed-js'].includes('instagram.com')) {
                      return <InstagramEmbed embedJs={story['embed-js']} />;
                    }
                  }
                  return <GumletEmbed embedJs={story['embed-js']} />;
                })()}
                      </div>}
                    {/* Story-level YouTube video */}
                    {story['embed-url'] && <div className="border-b border-DCDCDC">
                        <YouTubeThumbnail embedUrl={story['embed-url']} thumbnailUrl={imageUrl} title={story.headline} />
                      </div>}
                    <div className="p-4 border-b border-DCDCDC">
                      {/* {story.sections?.[0]?.name && !HIDDEN_CATEGORY_NAMES.includes(story.sections[0].name?.trim()) && (
                        <p className="text-16-tamil-600 text-012061 mb-2">{story.sections[0].name}</p>
                       )} */}
                      {/* <p className="text-14-tamil-600 underline decoration-012061 underline-offset-12">
                        By {story['author-name']}
                       </p> */}
                      {hasVisibleAuthors(story) && <div className="flex items-center gap-2 mt-4 mb-6">
                          {filterAuthors(story['authors'])[0]?.['avatar-s3-key'] && <img src={getImageUrl(filterAuthors(story['authors'])[0]['avatar-s3-key'])} alt={filterAuthors(story['authors'])[0].name || 'Author'} className="w-8 h-8 rounded-full object-cover flex-shrink-0" />}
                          <p className="text-14-tamil-500 text-4D4D4D">
                            {filterAuthors(story['authors']).map((author: any, index: number) => <span key={author.id}>
                                {index > 0 && ', '}
                                <Link href={`/author/${author.slug}`} className="text-14-tamil-600 sm:text-18-tamil-600 text-1B1B1B hover:text-012061">
                                  {author.name}
                                </Link>
                              </span>)}
                          </p>
                        </div>}

                      <div className="space-y-4">
                        {(() => {
                    const paraMap = computeParagraphMap(story);
                    return story.cards?.map((card: any, cardIdx: number) => <div key={cardIdx}>
                              <div>
                                {card['story-elements']?.map((element: any, elementIdx: number) => {
                          const paraInfo = paraMap[`${cardIdx}_${elementIdx}`];
                          const isRegularText = element.type === 'text' && element.text && element.subtype !== 'summary' && element.subtype !== 'also-read' && !element.metadata?.['promotional-message'];
                          return <div key={elementIdx}>
                                      {element.type === 'file' && element['content-type'] === 'application/pdf' && <div className="mb-4">
                                          <PdfFile fileName={element['file-name']} url={element.url} s3Key={element['s3-key']} />
                                        </div>}
                                      {element.type === 'jsembed' && element.subtype === 'tweet' && <TweetEmbed embedJs={element['embed-js']} />}
                                      {element.type === 'jsembed' && element.subtype === 'instagram' && <InstagramEmbed embedJs={element['embed-js']} />}
                                      {element.type === 'jsembed' && element.subtype !== 'tweet' && element.subtype !== 'instagram' && <VideoEmbed embedJs={element['embed-js']} type={element.type} subtype={element.subtype} />}
                                      {element.type === 'youtube-video' && element['embed-url'] && <YouTubeThumbnail embedUrl={element['embed-url']} thumbnailUrl={imageUrl} title={element.title} />}
                                      {element.type === 'image' && element['image-s3-key'] && <div className="mb-4">
                                          <div className="relative w-full h-[300px] sm:h-[400px] md:h-[470px] bg-gray-100 p-[5px] rounded overflow-hidden">
                                            <img src={getImageUrl(element['image-s3-key'])} alt="" className="absolute inset-0 w-full h-full object-cover blur-xl scale-110" aria-hidden="true" />
                                            <img src={getImageUrl(element['image-s3-key'])} alt={element.title || element['alt-text'] || 'Story image'} className="relative w-full h-full object-contain" />
                                          </div>
                                          {(element.title || element['image-attribution']) && <div className="p-2 text-12-tamil-400 sm:text-16-tamil-400">
                                              <p>
                                                {element.title && <span className="text-black">{element.title}</span>}
                                                {element.title && element['image-attribution'] && ' - '}
                                                {element['image-attribution'] && <span style={{
                                    color: '#00000099'
                                  }}>{element['image-attribution']}</span>}
                                              </p>
                                            </div>}
                                        </div>}
                                      {element.type === 'data' && element.subtype === 'table' && <TableEmbed data={element.data} />}
                                      {element.subtype === 'also-read' && element.text && (() => {
                              const linkedStoryId = element.metadata?.['linked-story-id'] || element['linked-story-id'];
                              const linkedStory = linkedStoryId && story['linked-stories']?.[linkedStoryId] || element.metadata?.['linked-story'];
                              if (linkedStory && linkedStory.slug) {
                                return <a href={`/${linkedStory.slug}`} className="flex flex-col sm:flex-row gap-3 border border-DCDCDC overflow-hidden hover:shadow-md transition-shadow my-3 p-4">
                                              {linkedStory['hero-image-s3-key'] && <div className="w-full sm:w-[150px] h-[160px] sm:h-[100px] flex-shrink-0">
                                                  <img src={getImageUrl(linkedStory['hero-image-s3-key'])} alt={linkedStory.headline} className="w-full h-full object-cover" />
                                                </div>}
                                              <div className="p-3 flex-1 flex items-center">
 <h4 className="text-16-tamil-700 text-1B1B1B">
                                                  {linkedStory.headline || element.text}
                                                </h4>
                                              </div>
                                            </a>;
                              }
                              return null;
                            })()}
                                      {element.subtype === 'summary' && element.text && <div className="mb-8">
 <h3 className="text-18-tamil-700 text-1B1B1B mb-4 mt-2">Summary</h3>
                                          <div className="text-18-tamil-400 text-1B1B1B mb-6 article-links [&_p]:mb-4" dangerouslySetInnerHTML={{
                                __html: processArticleLinks(element.text)
                              }} />

                                          {/* Linked Stories Section - after summary */}
                                          {story['linked-stories'] && Object.keys(story['linked-stories']).length > 0 && <div className="mt-6 mb-8">
                                              <div className="grid grid-cols-1 gap-4">
                                                {Object.entries(story['linked-stories']).filter(([key]) => !inlineAlsoReadIds.has(key)).map(([key, linkedStory]: [string, any]) => <a key={key} href={`/${linkedStory.slug}`} className="flex flex-col lg:flex-row gap-3 lg:gap-4 p-4 border border-DCDCDC overflow-hidden hover:shadow-md transition-shadow">
                                                    {/* Image - Left side on large screens */}
                                                    {linkedStory['hero-image-s3-key'] && <div className="w-full lg:w-[200px] h-[200px] lg:h-[120px] flex-shrink-0">
                                                        <img src={getImageUrl(linkedStory['hero-image-s3-key'])} alt={linkedStory.headline} className="w-full h-full object-cover" />
                                                      </div>}
                                                    {/* Text - Right side on large screens */}
                                                    <div className="p-3 lg:p-4 flex-1 flex items-center">
 <h4 className="text-16-tamil-700 lg:text-18-tamil-700 text-1B1B1B">
                                                        {linkedStory.headline}
                                                      </h4>
                                                    </div>
                                                  </a>)}
                                              </div>
                                            </div>}
                                        </div>}
                                      {/* Regular text: split by paragraphs and insert ads between them */}
                                      {isRegularText && paraInfo && paraInfo.paragraphs.length > 0 && <>
                                          {paraInfo.paragraphs.map((paraHtml: string, paraIdx: number) => {
                                const globalIdx = paraInfo.startIndex + paraIdx;
                                const showAd = hasInlineAdCodes && shouldShowAdAfterParagraph(globalIdx);
                                if (showAd) {}
                                return <div key={`p-${paraIdx}`}>
                                                <div className="text-18-tamil-400 text-1B1B1B article-links [&_p]:mb-4" dangerouslySetInnerHTML={{
                                    __html: processArticleLinks(paraHtml)
                                  }} />
                                                {/* Inline ad after paragraph based on global paragraph count */}
                                                {hasInlineAdCodes && shouldShowAdAfterParagraph(globalIdx) && <InlineArticleAd rosInreadAdCode={rosInreadAdCode} multipleAdSlots={multipleAdSlots} inlinePosition={getAdPositionForParagraph(globalIdx)} adIndex={globalIdx} />}
                                              </div>;
                              })}
                                        </>}
                                      {/* Fallback: text elements without <p> tags or promotional messages render as-is */}
                                      {isRegularText && (!paraInfo || paraInfo.paragraphs.length === 0) && <div className="text-18-tamil-400 text-1B1B1B article-links [&_p]:mb-4" dangerouslySetInnerHTML={{
                              __html: processArticleLinks(element.text)
                            }} />}
                                      {/* Promotional message text - render as-is without ad insertion, dim color */}
                                      {element.type === 'text' && element.text && element.metadata?.['promotional-message'] && element.subtype !== 'summary' && element.subtype !== 'also-read' && <div className="text-14-tamil-400 article-links [&_p]:mb-4" style={{
                              color: '#00000099'
                            }} dangerouslySetInnerHTML={{
                              __html: processArticleLinks(element.text)
                            }} />}
                                    </div>;
                        })}
                              </div>
                            </div>);
                  })()}
                      </div>
                    </div>
                    <ArticleFooter />
                  </>}
                {(story['story-template'] === 'listicle' || story['story-template'] === 'review') && <>
                    <div className="border-b border-DCDCDC">
                      <BigNewsWithicon category={category} sectionUrl={sectionUrl} title={story.headline} excerpt={story.subheadline || story.summary} imageSrc={imageUrl} imageCaption={story['hero-image-caption']} imageAttribution={imageAttribution} imageMetadata={story['hero-image-metadata']} publishedAt={publishedAt} updatedAt={updatedAt} showPublished={showPublishedOn} slug={story.slug} articleUrl={`/${story.slug}`} />
                    </div>
                    {promotionBlock}
                    {showAudioPlayer && <AudioPlayer />}
                    {/* Story-level embed-js (video/tweet/instagram embed at story level) */}
                    {story['embed-js'] && <div className="border-b border-DCDCDC p-4">
                        {(() => {
                  try {
                    const decoded = atob(story['embed-js']);
                    if (decoded.includes('twitter-tweet') || decoded.includes('platform.twitter.com')) {
                      return <TweetEmbed embedJs={story['embed-js']} />;
                    }
                    if (decoded.includes('instagram-media') || decoded.includes('instagram.com')) {
                      return <InstagramEmbed embedJs={story['embed-js']} />;
                    }
                  } catch {
                    if (story['embed-js'].includes('twitter-tweet') || story['embed-js'].includes('platform.twitter.com')) {
                      return <TweetEmbed embedJs={story['embed-js']} />;
                    }
                    if (story['embed-js'].includes('instagram-media') || story['embed-js'].includes('instagram.com')) {
                      return <InstagramEmbed embedJs={story['embed-js']} />;
                    }
                  }
                  return <GumletEmbed embedJs={story['embed-js']} />;
                })()}
                      </div>}
                    {/* Story-level YouTube video */}
                    {story['embed-url'] && <div className="border-b border-DCDCDC">
                        <YouTubeThumbnail embedUrl={story['embed-url']} thumbnailUrl={imageUrl} title={story.headline} />
                      </div>}
                    {/* Author and Updated On for listicle template */}
                    {story['story-template'] === 'listicle' && <div className="p-4 border-b border-DCDCDC">
                        <div className="flex flex-col gap-1">
                          {hasVisibleAuthors(story) && <div className="flex items-center gap-2 mb-4">
                              {filterAuthors(story.authors)[0]?.['avatar-s3-key'] && <img src={getImageUrl(filterAuthors(story.authors)[0]['avatar-s3-key'])} alt={filterAuthors(story.authors)[0].name || 'Author'} className="w-8 h-8 rounded-full object-cover flex-shrink-0" />}
                              <div className="text-14-tamil-500 text-4D4D4D">
                                {filterAuthors(story.authors).map((author: any, idx: number) => <span key={author.id}>
                                    {idx > 0 && ', '}
                                    <Link href={`/author/${author.slug}`} className="text-14-tamil-600 sm:text-18-tamil-600 text-1B1B1B hover:text-012061">
                                      {author.name}
                                    </Link>
                                  </span>)}
                              </div>
                            </div>}
                          <div className="flex items-center gap-1">
                            <span className="text-12-tamil-300 text-1B1B1B">Updated On :</span>
                            <span className="text-12-tamil-500 text-1B1B1B">{updatedAt}</span>
                          </div>
                        </div>
                      </div>}
                    {/* Show review-title, rating and author for review template */}
                    {story['story-template'] === 'review' && (story.metadata?.['review-title'] || story.metadata?.['review-rating'] || hasVisibleAuthors(story)) && <div className="p-4 border-b border-DCDCDC">
                        <div className="flex items-center justify-between gap-4">
                          {/* Review title on left */}
                          {story.metadata?.['review-title'] && <p className="text-18-tamil-400 text-4D4D4D flex-1">{story.metadata['review-title']}</p>}
                          {/* Rating on right */}
                          {story.metadata?.['review-rating'] && (() => {
                    const ratingValue = parseFloat(story.metadata['review-rating']?.value || story.metadata['review-rating']?.label || '0');
                    const starPath = "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z";
                    return <div className="flex items-center gap-2 shrink-0">
                                <div className="flex items-center gap-0.5">
                                  {[1, 2, 3, 4, 5].map(star => {
                          if (ratingValue >= star) {
                            return <svg key={star} className="w-5 h-5" viewBox="0 0 20 20">
                                          <path d={starPath} fill="#eab308" stroke="#eab308" strokeWidth="0.5" />
                                        </svg>;
                          } else if (ratingValue >= star - 0.5) {
                            return <svg key={star} className="w-5 h-5" viewBox="0 0 20 20">
                                          <defs><clipPath id={`half-${star}`}><rect x="0" y="0" width="10" height="20" /></clipPath></defs>
                                          <path d={starPath} fill="#eab308" opacity="0.3" stroke="#eab308" strokeWidth="0.5" />
                                          <path d={starPath} fill="#eab308" clipPath={`url(#half-${star})`} stroke="#eab308" strokeWidth="0.5" />
                                        </svg>;
                          } else {
                            return <svg key={star} className="w-5 h-5" viewBox="0 0 20 20">
                                          <path d={starPath} fill="#eab308" opacity="0.3" stroke="#eab308" strokeWidth="0.5" />
                                        </svg>;
                          }
                        })}
                                </div>
                                <span className="text-16-tamil-700 text-1B1B1B">{story.metadata['review-rating']?.value || story.metadata['review-rating']?.label}/5</span>
                              </div>;
                  })()}
                        </div>
                        {/* Author name */}
                        {hasVisibleAuthors(story) && <div className="flex items-center gap-2 mt-2 mb-4">
                            {filterAuthors(story.authors)[0]?.['avatar-s3-key'] && <img src={getImageUrl(filterAuthors(story.authors)[0]['avatar-s3-key'])} alt={filterAuthors(story.authors)[0].name || 'Author'} className="w-8 h-8 rounded-full object-cover flex-shrink-0" />}
                            <p className="text-14-tamil-500 text-4D4D4D">
                              {filterAuthors(story.authors).map((author: any, idx: number) => <span key={author.id}>
                                  {idx > 0 && ', '}
                                  <Link href={`/author/${author.slug}`} className="text-14-tamil-600 sm:text-18-tamil-600 text-1B1B1B hover:text-012061">
                                    {author.name}
                                  </Link>
                                </span>)}
                            </p>
                          </div>}
                      </div>}
                    <div>
                      {(() => {
                  let titleCount = 0;
                  return story.cards?.map((card: any, cardIdx: number) => <div key={cardIdx}>
                            <div className="px-4 py-2">
                              {card['story-elements']?.map((element: any, elementIdx: number) => {
                        // Increment counter for title type elements
                        if (element.type === 'title') {
                          titleCount++;
                        }
                        return <div key={elementIdx} className="mb-1">
                                    {/* Title type with count number and larger font */}
                                    {element.type === 'title' && element.text && <h3 className="text-24-tamil-700 text-012061 mb-1 mt-2 flex items-start gap-3">
                                        <span className="bg-012061 text-white rounded-full w-8 h-8 flex items-center justify-center text-16-english-700 shrink-0">{titleCount}</span>
                                        <span dangerouslySetInnerHTML={{
                              __html: element.text.replace(/<\/?p>/g, '')
                            }} />
                                      </h3>}
                                    {element.title && element.type !== 'title' && element.type !== 'image' && <h3 className="text-18-tamil-700 text-1B1B1B mb-1">{element.title}</h3>}
                                    {element.type === 'jsembed' && element.subtype === 'tweet' && <TweetEmbed embedJs={element['embed-js']} />}
                                    {element.type === 'jsembed' && element.subtype === 'instagram' && <InstagramEmbed embedJs={element['embed-js']} />}
                                    {element.type === 'jsembed' && element.subtype !== 'tweet' && element.subtype !== 'instagram' && <VideoEmbed embedJs={element['embed-js']} type={element.type} subtype={element.subtype} />}
                                    {element.type === 'youtube-video' && element['embed-url'] && <YouTubeThumbnail embedUrl={element['embed-url']} thumbnailUrl={imageUrl} title={element.title} />}
                                    {element.subtype === 'summary' && element.text && <div>
 <h3 className="text-18-tamil-700 text-1B1B1B mb-1">Summary</h3>
                                        <div className="text-18-tamil-400 text-1B1B1B article-links [&_p]:mb-4" dangerouslySetInnerHTML={{
                              __html: processArticleLinks(element.text)
                            }} />
                                      </div>}
                                    {element.text && element.subtype !== 'summary' && element.subtype !== 'also-read' && element.type !== 'jsembed' && element.type !== 'youtube-video' && element.type !== 'title' && !element.metadata?.['promotional-message'] && <div className="text-18-tamil-400 text-1B1B1B article-links [&_p]:mb-4" dangerouslySetInnerHTML={{
                            __html: processArticleLinks(element.text)
                          }} />}
                                    {element.text && element.metadata?.['promotional-message'] && <div className="text-14-tamil-400 article-links [&_p]:mb-4" style={{
                            color: '#00000099'
                          }} dangerouslySetInnerHTML={{
                            __html: processArticleLinks(element.text)
                          }} />}
                                    {element.subtype === 'also-read' && element.text && (() => {
                            const linkedStoryId = element.metadata?.['linked-story-id'] || element['linked-story-id'];
                            const linkedStory = linkedStoryId && story['linked-stories']?.[linkedStoryId] || element.metadata?.['linked-story'];
                            if (linkedStory && linkedStory.slug) {
                              return <a href={`/${linkedStory.slug}`} className="flex flex-col sm:flex-row gap-3 border border-DCDCDC overflow-hidden hover:shadow-md transition-shadow my-3 p-4">
                                            {linkedStory['hero-image-s3-key'] && <div className="w-full sm:w-[150px] h-[160px] sm:h-[100px] flex-shrink-0">
                                                <img src={getImageUrl(linkedStory['hero-image-s3-key'])} alt={linkedStory.headline} className="w-full h-full object-cover" />
                                              </div>}
                                            <div className="p-3 flex-1 flex items-center">
 <h4 className="text-16-tamil-700 text-1B1B1B">
                                                {linkedStory.headline}
                                              </h4>
                                            </div>
                                          </a>;
                            }
                            return null;
                          })()}
                                    {element['image-s3-key'] && <div>
                                        <div className="relative w-full h-[300px] sm:h-[400px] md:h-[470px] bg-gray-100 p-[5px] overflow-hidden">
                                          <img src={getImageUrl(element['image-s3-key'])} alt="" className="absolute inset-0 w-full h-full object-cover blur-xl scale-110" aria-hidden="true" />
                                          <img src={getImageUrl(element['image-s3-key'])} alt={element.title || 'Listicle image'} className="relative w-full h-full object-contain" />
                                        </div>
                                        {element.title && <div className="p-2 text-14-tamil-600 sm:text-16-tamil-600 text-1B1B1B">
                                            <p>{element.title}</p>
                                          </div>}
                                        {element['image-attribution'] && <div className="px-2 pb-2 text-12-tamil-400 sm:text-16-tamil-400">
                                            <p style={{
                                color: '#00000099'
                              }}>{element['image-attribution']}</p>
                                          </div>}
                                      </div>}
                                  </div>;
                      })}
                            </div>
                            {/* Card-based ad: after 1st card, then every 2 cards */}
                            {hasInlineAdCodes && (cardIdx === 0 || cardIdx > 0 && cardIdx % 2 === 0) && <InlineArticleAd rosInreadAdCode={rosInreadAdCode} multipleAdSlots={multipleAdSlots} inlinePosition={cardIdx === 0 ? 0 : Math.floor(cardIdx / 2)} adIndex={1000 + cardIdx} />}
                          </div>);
                })()}
                      {/* Also-read: render linked stories at the end */}
                      {story['linked-stories'] && Object.keys(story['linked-stories']).length > 0 && <div className="p-4">
                          <div className="grid grid-cols-1 gap-4">
                            {Object.entries(story['linked-stories']).filter(([key]) => !inlineAlsoReadIds.has(key)).map(([key, linkedStory]: [string, any]) => <a key={key} href={`/${linkedStory.slug}`} className="flex flex-col sm:flex-row gap-3 border border-DCDCDC overflow-hidden hover:shadow-md transition-shadow p-4">
                                {linkedStory['hero-image-s3-key'] && <div className="w-full sm:w-[150px] h-[160px] sm:h-[100px] flex-shrink-0">
                                    <img src={getImageUrl(linkedStory['hero-image-s3-key'])} alt={linkedStory.headline} className="w-full h-full object-cover" />
                                  </div>}
                                <div className="p-3 flex-1 flex items-center">
 <h4 className="text-16-tamil-700 text-1B1B1B">
                                    {linkedStory.headline}
                                  </h4>
                                </div>
                              </a>)}
                          </div>
                        </div>}
                    </div>
                    <ArticleFooter />
                  </>}
                {story['story-template'] === 'video' && <>
                    <div className="border-b border-DCDCDC">
                      <BigNewsVideo category={category} sectionUrl={sectionUrl} title={story.headline} excerpt={story.subheadline || story.summary} embedUrl={story['embed-url']} thumbnailUrl={imageUrl} imageCaption={story['hero-image-caption']} imageAttribution={imageAttribution} publishedAt={publishedAt} updatedAt={updatedAt} cards={story.cards} showPublished={showPublishedOn} slug={story.slug} articleUrl={`/${story.slug}`} />
                    </div>
                    {promotionBlock}
                    {showAudioPlayer && <AudioPlayer />}
                    {/* Story-level embed-js (video/tweet/instagram embed at story level) */}
                    {story['embed-js'] && <div className="border-b border-DCDCDC p-4">
                        {(() => {
                  try {
                    const decoded = atob(story['embed-js']);
                    if (decoded.includes('twitter-tweet') || decoded.includes('platform.twitter.com')) {
                      return <TweetEmbed embedJs={story['embed-js']} />;
                    }
                    if (decoded.includes('instagram-media') || decoded.includes('instagram.com')) {
                      return <InstagramEmbed embedJs={story['embed-js']} />;
                    }
                  } catch {
                    if (story['embed-js'].includes('twitter-tweet') || story['embed-js'].includes('platform.twitter.com')) {
                      return <TweetEmbed embedJs={story['embed-js']} />;
                    }
                    if (story['embed-js'].includes('instagram-media') || story['embed-js'].includes('instagram.com')) {
                      return <InstagramEmbed embedJs={story['embed-js']} />;
                    }
                  }
                  return <GumletEmbed embedJs={story['embed-js']} />;
                })()}
                      </div>}
                    {/* Subheadline already shown in BigNewsVideo via excerpt prop */}
                    <div className="p-4 border-b border-DCDCDC">
                      {hasVisibleAuthors(story) && <div className="flex items-center gap-2 mt-4 mb-6">
                          {filterAuthors(story['authors'])[0]?.['avatar-s3-key'] && <img src={getImageUrl(filterAuthors(story['authors'])[0]['avatar-s3-key'])} alt={filterAuthors(story['authors'])[0].name || 'Author'} className="w-8 h-8 rounded-full object-cover flex-shrink-0" />}
                          <p className="text-14-tamil-500 text-4D4D4D">
                            {filterAuthors(story['authors']).map((author: any, index: number) => <span key={author.id}>
                                {index > 0 && ', '}
                                <Link href={`/author/${author.slug}`} className="text-14-tamil-600 sm:text-18-tamil-600 text-1B1B1B hover:text-012061">
                                  {author.name}
                                </Link>
                              </span>)}
                          </p>
                        </div>}

                      <div className="space-y-4">
                        {story.cards?.map((card: any, cardIdx: number) => <div key={cardIdx}>
                            <div>
                              {card['story-elements']?.map((element: any, elementIdx: number) => <div key={elementIdx}>
                                  {element.type === 'jsembed' && element.subtype === 'tweet' && <TweetEmbed embedJs={element['embed-js']} />}
                                  {element.type === 'jsembed' && element.subtype === 'instagram' && <InstagramEmbed embedJs={element['embed-js']} />}
                                  {element.type === 'jsembed' && element.subtype !== 'tweet' && element.subtype !== 'instagram' && <VideoEmbed embedJs={element['embed-js']} type={element.type} subtype={element.subtype} />}
                                  {/* YouTube video already shown in BigNewsVideo component */}
                                  {element.subtype === 'summary' && element.text && <div>
 <h3 className="text-18-tamil-700 text-1B1B1B mb-2">Summary</h3>
                                      <div className="text-18-tamil-400 text-1B1B1B mb-4 article-links [&_p]:mb-4" dangerouslySetInnerHTML={{
                            __html: processArticleLinks(element.text)
                          }} />
                                    </div>}
                                  {element.text && element.subtype !== 'summary' && element.subtype !== 'also-read' && element.type !== 'jsembed' && element.type !== 'youtube-video' && !element.metadata?.['promotional-message'] && <div className="text-18-tamil-400 text-1B1B1B mb-4 article-links [&_p]:mb-4" dangerouslySetInnerHTML={{
                          __html: processArticleLinks(element.text)
                        }} />}
                                  {element.text && element.metadata?.['promotional-message'] && <div className="text-14-tamil-400 article-links [&_p]:mb-4" style={{
                          color: '#00000099'
                        }} dangerouslySetInnerHTML={{
                          __html: processArticleLinks(element.text)
                        }} />}
                                  {element.subtype === 'also-read' && element.text && (() => {
                          const linkedStoryId = element.metadata?.['linked-story-id'] || element['linked-story-id'];
                          const linkedStory = linkedStoryId && story['linked-stories']?.[linkedStoryId] || element.metadata?.['linked-story'];
                          if (linkedStory && linkedStory.slug) {
                            return <a href={`/${linkedStory.slug}`} className="flex flex-col sm:flex-row gap-3 border border-DCDCDC overflow-hidden hover:shadow-md transition-shadow my-3 p-4">
                                          {linkedStory['hero-image-s3-key'] && <div className="w-full sm:w-[150px] h-[160px] sm:h-[100px] flex-shrink-0">
                                              <img src={getImageUrl(linkedStory['hero-image-s3-key'])} alt={linkedStory.headline} className="w-full h-full object-cover" />
                                            </div>}
                                          <div className="p-3 flex-1 flex items-center">
 <h4 className="text-16-tamil-700 text-1B1B1B">
                                              {linkedStory.headline}
                                            </h4>
                                          </div>
                                        </a>;
                          }
                          return null;
                        })()}
                                </div>)}
                            </div>
                            {/* Card-based ad: after 1st card, then every 2 cards */}
                            {hasInlineAdCodes && (cardIdx === 0 || cardIdx > 0 && cardIdx % 2 === 0) && <InlineArticleAd rosInreadAdCode={rosInreadAdCode} multipleAdSlots={multipleAdSlots} inlinePosition={cardIdx === 0 ? 0 : Math.floor(cardIdx / 2)} adIndex={2000 + cardIdx} />}
                          </div>)}
                      </div>

                      {/* Linked Stories Section - at the end */}
                      {story['linked-stories'] && Object.keys(story['linked-stories']).length > 0 && <div className="p-4">
                          <div className="grid grid-cols-1 gap-4">
                            {Object.entries(story['linked-stories']).filter(([key]) => !inlineAlsoReadIds.has(key)).map(([key, linkedStory]: [string, any]) => <a key={key} href={`/${linkedStory.slug}`} className="flex flex-col sm:flex-row gap-3 border border-DCDCDC overflow-hidden hover:shadow-md transition-shadow p-4">
                                {linkedStory['hero-image-s3-key'] && <div className="w-full sm:w-[150px] h-[160px] sm:h-[100px] flex-shrink-0">
                                    <img src={getImageUrl(linkedStory['hero-image-s3-key'])} alt={linkedStory.headline} className="w-full h-full object-cover" />
                                  </div>}
                                <div className="p-3 flex-1 flex items-center">
 <h4 className="text-16-tamil-700 text-1B1B1B">
                                    {linkedStory.headline}
                                  </h4>
                                </div>
                              </a>)}
                          </div>
                        </div>}

                    </div>
                    <ArticleFooter />
                  </>}
                {story['story-template'] === 'question-and-answer' && <>
                    {/* Hero Image */}
                    {imageUrl && <div className="border-b border-DCDCDC">
                        <img src={imageUrl} alt={story.headline || 'Question and Answer'} className="w-full aspect-[16/9] max-h-[475px] object-cover" style={getFocusPointStyle(story['hero-image-metadata'])} />
                        {(story['hero-image-caption'] || imageAttribution) && <div className="p-2 text-12-tamil-400 sm:text-16-tamil-400">
                            <p>
                              {story['hero-image-caption'] && <span className="text-black">{story['hero-image-caption']}</span>}
                              {story['hero-image-caption'] && imageAttribution && ' - '}
                              {imageAttribution && <span style={{
                      color: '#00000099'
                    }}>{imageAttribution}</span>}
                            </p>
                          </div>}
                      </div>}

                    {/* Headline and Meta Info */}
                    <div className="relative p-4 border-b border-DCDCDC">
                      {/* Bookmark/Reaction Icons & Share - Top Right */}
                      <div className="absolute top-4 right-4 z-10 flex items-center gap-1">
                        <MessageIconLogo id={`qa-${story.slug}`} variant="message-icon-3" slug={story.slug} category={BOOKMARK_CATEGORIES.NEWS} title={story.headline} thumbnailUrl={imageUrl} description={story.subheadline} articleUrl={`/${story.slug}`} />
                      </div>
                      {story.sections?.[0]?.name && !HIDDEN_CATEGORY_NAMES.includes(story.sections[0].name?.trim()) && <Link href={`/${getPathFromUrl(story.sections[0]?.['section-url'] || '')}`}>
 <h2 className="text-16-tamil-600 text-012061 mb-2 hover:underline cursor-pointer">{story.sections[0].name}</h2>
                        </Link>}
 <h1 className="text-24-tamil-700 text-1B1B1B mb-2">{story.headline}</h1>
                      <div className="flex flex-col gap-1">
                        {hasVisibleAuthors(story) && <div className="flex items-center gap-2 mb-4">
                            {filterAuthors(story.authors)[0]?.['avatar-s3-key'] && <img src={getImageUrl(filterAuthors(story.authors)[0]['avatar-s3-key'])} alt={filterAuthors(story.authors)[0].name || 'Author'} className="w-8 h-8 rounded-full object-cover flex-shrink-0" />}
                            <div className="text-14-tamil-500 text-4D4D4D">
                              {filterAuthors(story.authors).map((author: any, idx: number) => <span key={author.id}>
                                  {idx > 0 && ', '}
                                  <Link href={`/author/${author.slug}`} className="text-14-tamil-600 sm:text-18-tamil-600 text-1B1B1B hover:text-012061">
                                    {author.name}
                                  </Link>
                                </span>)}
                            </div>
                          </div>}
                        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
                          <div className="flex items-center gap-1">
                            <span className="text-12-tamil-300 text-1B1B1B">Updated On :</span>
                            <span className="text-12-tamil-500 text-1B1B1B">{updatedAt}</span>
                          </div>
                          <ArticleShareButtons slug={story.slug} title={story.headline} className="!p-0 !gap-1" />
                        </div>
                      </div>
                    </div>
                    {promotionBlock}

                    {/* Story-level embed-js (video/tweet/instagram embed at story level) */}
                    {story['embed-js'] && <div className="border-b border-DCDCDC p-4">
                        {(() => {
                  try {
                    const decoded = atob(story['embed-js']);
                    if (decoded.includes('twitter-tweet') || decoded.includes('platform.twitter.com')) {
                      return <TweetEmbed embedJs={story['embed-js']} />;
                    }
                    if (decoded.includes('instagram-media') || decoded.includes('instagram.com')) {
                      return <InstagramEmbed embedJs={story['embed-js']} />;
                    }
                  } catch {
                    if (story['embed-js'].includes('twitter-tweet') || story['embed-js'].includes('platform.twitter.com')) {
                      return <TweetEmbed embedJs={story['embed-js']} />;
                    }
                    if (story['embed-js'].includes('instagram-media') || story['embed-js'].includes('instagram.com')) {
                      return <InstagramEmbed embedJs={story['embed-js']} />;
                    }
                  }
                  return <GumletEmbed embedJs={story['embed-js']} />;
                })()}
                      </div>}
                    {/* Story-level YouTube video */}
                    {story['embed-url'] && <div className="border-b border-DCDCDC">
                        <YouTubeThumbnail embedUrl={story['embed-url']} thumbnailUrl={imageUrl} title={story.headline} />
                      </div>}

                    {/* Story Elements */}
                    <div className="p-4 space-y-6">
                      {story.cards?.map((card: any, cardIdx: number) => <div key={cardIdx}>
                          <div>
                            {card['story-elements']?.map((element: any, elementIdx: number) => <div key={elementIdx} className="mb-6">
                                {element.type === 'jsembed' && element.subtype === 'tweet' && <TweetEmbed embedJs={element['embed-js']} />}
                                {element.type === 'jsembed' && element.subtype === 'instagram' && <InstagramEmbed embedJs={element['embed-js']} />}
                                {element.type === 'jsembed' && element.subtype !== 'tweet' && element.subtype !== 'instagram' && <VideoEmbed embedJs={element['embed-js']} type={element.type} subtype={element.subtype} />}
                                {element.type === 'youtube-video' && element['embed-url'] && <YouTubeThumbnail embedUrl={element['embed-url']} thumbnailUrl={imageUrl} title={element.title} />}
                                {/* Also-read: render linked story inline */}
                                {element.subtype === 'also-read' && element.text && (() => {
                        const linkedStoryId = element.metadata?.['linked-story-id'] || element['linked-story-id'];
                        const linkedStory = linkedStoryId && story['linked-stories']?.[linkedStoryId] || element.metadata?.['linked-story'];
                        if (linkedStory && linkedStory.slug) {
                          return <a href={`/${linkedStory.slug}`} className="flex flex-col sm:flex-row gap-3 border border-DCDCDC overflow-hidden hover:shadow-md transition-shadow my-3 p-4">
                                        {linkedStory['hero-image-s3-key'] && <div className="w-full sm:w-[150px] h-[160px] sm:h-[100px] flex-shrink-0">
                                            <img src={getImageUrl(linkedStory['hero-image-s3-key'])} alt={linkedStory.headline} className="w-full h-full object-cover" />
                                          </div>}
                                        <div className="p-3 flex-1 flex items-center">
 <h4 className="text-16-tamil-700 text-1B1B1B">
                                            {linkedStory.headline}
                                          </h4>
                                        </div>
                                      </a>;
                        }
                        return null;
                      })()}
                                {element.subtype === 'question' && element.type !== 'jsembed' && element.type !== 'youtube-video' ? (/* Question Design */
                      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
 <h3 className="text-18-tamil-700 text-1B1B1B mb-4 article-links [&_p]:mb-4">
                                      <div dangerouslySetInnerHTML={{
                            __html: processArticleLinks(element.text)
                          }} />
                                    </h3>
                                  </div>) : element.type !== 'jsembed' && element.type !== 'youtube-video' && element.subtype !== 'also-read' && !element.metadata?.['promotional-message'] && (/* Regular News Design */
                      <div className="space-y-4">
                                    {element.text && <div className="text-18-tamil-400 text-1B1B1B article-links [&_p]:mb-4" dangerouslySetInnerHTML={{
                          __html: processArticleLinks(element.text)
                        }} />}
                                  </div>)}
                                {element.text && element.metadata?.['promotional-message'] && <div className="text-14-tamil-400 article-links [&_p]:mb-4" style={{
                        color: '#00000099'
                      }} dangerouslySetInnerHTML={{
                        __html: processArticleLinks(element.text)
                      }} />}
                              </div>)}
                          </div>
                          {/* Card-based ad: after 1st card, then every 2 cards */}
                          {hasInlineAdCodes && (cardIdx === 0 || cardIdx > 0 && cardIdx % 2 === 0) && <InlineArticleAd rosInreadAdCode={rosInreadAdCode} multipleAdSlots={multipleAdSlots} inlinePosition={cardIdx === 0 ? 0 : Math.floor(cardIdx / 2)} adIndex={3000 + cardIdx} />}
                        </div>)}

                      {/* Linked Stories Section */}
                      {story['linked-stories'] && Object.keys(story['linked-stories']).length > 0 && <div className="p-4">
                          <div className="grid grid-cols-1 gap-4">
                            {Object.entries(story['linked-stories']).filter(([key]) => !inlineAlsoReadIds.has(key)).map(([key, linkedStory]: [string, any]) => <a key={key} href={`/${linkedStory.slug}`} className="flex flex-col lg:flex-row gap-3 lg:gap-4 p-4 border border-DCDCDC overflow-hidden hover:shadow-md transition-shadow">
                                {linkedStory['hero-image-s3-key'] && <div className="w-full lg:w-[200px] h-[200px] lg:h-[120px] flex-shrink-0">
                                    <img src={getImageUrl(linkedStory['hero-image-s3-key'])} alt={linkedStory.headline} className="w-full h-full object-cover" />
                                  </div>}
                                <div className="p-3 lg:p-4 flex-1 flex items-center">
 <h4 className="text-16-tamil-700 lg:text-18-tamil-700 text-1B1B1B">
                                    {linkedStory.headline}
                                  </h4>
                                </div>
                              </a>)}
                          </div>
                        </div>}
                    </div>
                    <ArticleFooter />
                  </>}
                {story['story-template'] === 'gumlet-video' && <>
                    {/* Headline and Meta Info */}
                    <div className="relative p-4 border-b border-DCDCDC">
                      {/* Bookmark/Reaction Icons & Share - Top Right */}
                      <div className="absolute top-4 right-4 z-10 flex items-center gap-1">
                        <MessageIconLogo id={`gumlet-${story.slug}`} variant="message-icon-3" slug={story.slug} category={BOOKMARK_CATEGORIES.VIDEOS} title={story.headline} thumbnailUrl={imageUrl} description={story.subheadline} articleUrl={`/${story.slug}`} />
                      </div>
                      {story.sections?.[0]?.name && !HIDDEN_CATEGORY_NAMES.includes(story.sections[0].name?.trim()) && <Link href={`/${getPathFromUrl(story.sections[0]?.['section-url'] || '')}`}>
 <h2 className="text-16-tamil-600 text-012061 mb-2 hover:underline cursor-pointer">{story.sections[0].name}</h2>
                        </Link>}
 <h1 className="text-24-tamil-700 text-1B1B1B mb-2">{story.headline}</h1>
                      {story.subheadline && <h2 className="text-18-tamil-400 text-4D4D4D mb-4">{story.subheadline}</h2>}
                    </div>

                    {showAudioPlayer && <AudioPlayer />}

                    {/* Gumlet Video Embed - check story level first, then cards */}
                    <div className="border-b border-DCDCDC">
                      {(() => {
                  // First try story-level embed-js
                  if (story['embed-js']) {
                    return <GumletEmbed embedJs={story['embed-js']} />;
                  }
                  // If not found, look for jsembed in cards
                  const firstEmbed = story.cards?.flatMap((card: any) => card['story-elements']?.filter((el: any) => el.type === 'jsembed' && el['embed-js']) || [])?.[0];
                  if (firstEmbed) {
                    return <GumletEmbed embedJs={firstEmbed['embed-js']} />;
                  }
                  return null;
                })()}
                    </div>
                    {/* Story-level YouTube video */}
                    {story['embed-url'] && <div className="border-b border-DCDCDC">
                        <YouTubeThumbnail embedUrl={story['embed-url']} thumbnailUrl={imageUrl} title={story.headline} />
                      </div>}

                    {/* Author and Updated On - after video */}
                    <div className="p-4 border-b border-DCDCDC">
                      <div className="flex flex-col gap-1">
                        {hasVisibleAuthors(story) && <div className="flex items-center gap-2">
                            {filterAuthors(story.authors)[0]?.['avatar-s3-key'] && <img src={getImageUrl(filterAuthors(story.authors)[0]['avatar-s3-key'])} alt={filterAuthors(story.authors)[0].name || 'Author'} className="w-8 h-8 rounded-full object-cover flex-shrink-0" />}
                            <div className="text-14-tamil-500 text-4D4D4D">
                              {filterAuthors(story.authors).map((author: any, idx: number) => <span key={author.id}>
                                  {idx > 0 && ', '}
                                  <Link href={`/author/${author.slug}`} className="text-14-tamil-600 sm:text-18-tamil-600 text-1B1B1B hover:text-012061">
                                    {author.name}
                                  </Link>
                                </span>)}
                            </div>
                          </div>}
                        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
                          <div className="flex items-center gap-1">
                            <span className="text-12-tamil-300 text-1B1B1B">Updated On :</span>
                            <span className="text-12-tamil-500 text-1B1B1B">{updatedAt}</span>
                          </div>
                          <ArticleShareButtons slug={story.slug} title={story.headline} className="!p-0 !gap-1" />
                        </div>
                      </div>
                    </div>
                    {promotionBlock}

                    {/* Process cards for additional content (excluding first video embed which is shown above) */}
                    <div className="p-4 space-y-6">
                      {story.cards?.map((card: any, cardIdx: number) => {
                  // Track if we've already shown the first video embed
                  let firstVideoShown = false;
                  return <div key={cardIdx}>
                            <div>
                              {card['story-elements']?.map((element: any, elementIdx: number) => {
                        // Skip the first jsembed (video) since it's shown above
                        if (element.type === 'jsembed' && element['embed-js'] && !firstVideoShown && cardIdx === 0) {
                          firstVideoShown = true;
                          return null;
                        }
                        return <div key={elementIdx} className="mb-6">
                                    {element.type === 'file' && element['content-type'] === 'application/pdf' && <div className="mb-4">
                                        <PdfFile fileName={element['file-name']} url={element.url} s3Key={element['s3-key']} />
                                      </div>}
                                    {element.type === 'jsembed' && element.subtype === 'tweet' && <TweetEmbed embedJs={element['embed-js']} />}
                                    {element.type === 'jsembed' && element.subtype === 'instagram' && <InstagramEmbed embedJs={element['embed-js']} />}
                                    {element.type === 'jsembed' && element.subtype !== 'tweet' && element.subtype !== 'instagram' && <VideoEmbed embedJs={element['embed-js']} type={element.type} subtype={element.subtype} />}
                                    {element.type === 'youtube-video' && element['embed-url'] && <YouTubeThumbnail embedUrl={element['embed-url']} thumbnailUrl={imageUrl} title={element.title} />}
                                    {element.subtype === 'summary' && element.text && <div>
 <h3 className="text-18-tamil-700 text-1B1B1B mb-2">Summary</h3>
                                        <div className="text-18-tamil-400 text-1B1B1B mb-4 article-links [&_p]:mb-4" dangerouslySetInnerHTML={{
                              __html: processArticleLinks(element.text)
                            }} />
                                      </div>}
                                    {element.text && element.subtype !== 'summary' && element.subtype !== 'also-read' && element.type !== 'youtube-video' && !element.metadata?.['promotional-message'] && <div className="text-18-tamil-400 text-1B1B1B article-links [&_p]:mb-4" dangerouslySetInnerHTML={{
                            __html: processArticleLinks(element.text)
                          }} />}
                                    {element.text && element.metadata?.['promotional-message'] && <div className="text-14-tamil-400 article-links [&_p]:mb-4" style={{
                            color: '#00000099'
                          }} dangerouslySetInnerHTML={{
                            __html: processArticleLinks(element.text)
                          }} />}
                                    {element.subtype === 'also-read' && element.text && (() => {
                            const linkedStoryId = element.metadata?.['linked-story-id'] || element['linked-story-id'];
                            const linkedStory = linkedStoryId && story['linked-stories']?.[linkedStoryId] || element.metadata?.['linked-story'];
                            if (linkedStory && linkedStory.slug) {
                              return <a href={`/${linkedStory.slug}`} className="flex flex-col sm:flex-row gap-3 border border-DCDCDC overflow-hidden hover:shadow-md transition-shadow my-3 p-4">
                                            {linkedStory['hero-image-s3-key'] && <div className="w-full sm:w-[150px] h-[160px] sm:h-[100px] flex-shrink-0">
                                                <img src={getImageUrl(linkedStory['hero-image-s3-key'])} alt={linkedStory.headline} className="w-full h-full object-cover" />
                                              </div>}
                                            <div className="p-3 flex-1 flex items-center">
 <h4 className="text-16-tamil-700 text-1B1B1B">
                                                {linkedStory.headline}
                                              </h4>
                                            </div>
                                          </a>;
                            }
                            return null;
                          })()}
                                  </div>;
                      })}
                            </div>
                            {/* Card-based ad: after 1st card, then every 2 cards */}
                            {hasInlineAdCodes && (cardIdx === 0 || cardIdx > 0 && cardIdx % 2 === 0) && <InlineArticleAd rosInreadAdCode={rosInreadAdCode} multipleAdSlots={multipleAdSlots} inlinePosition={cardIdx === 0 ? 0 : Math.floor(cardIdx / 2)} adIndex={4000 + cardIdx} />}
                          </div>;
                })}

                      {/* Linked Stories Section */}
                      {story['linked-stories'] && Object.keys(story['linked-stories']).length > 0 && <div className="mb-6">
                          <div className="grid grid-cols-1 gap-4">
                            {Object.entries(story['linked-stories']).filter(([key]) => !inlineAlsoReadIds.has(key)).map(([key, linkedStory]: [string, any]) => <a key={key} href={`/${linkedStory.slug}`} className="flex flex-col lg:flex-row gap-3 lg:gap-4 p-4 border border-DCDCDC overflow-hidden hover:shadow-md transition-shadow">
                                {linkedStory['hero-image-s3-key'] && <div className="w-full lg:w-[200px] h-[200px] lg:h-[120px] flex-shrink-0">
                                    <img src={getImageUrl(linkedStory['hero-image-s3-key'])} alt={linkedStory.headline} className="w-full h-full object-cover" />
                                  </div>}
                                <div className="p-3 lg:p-4 flex-1 flex items-center">
 <h4 className="text-16-tamil-700 lg:text-18-tamil-700 text-1B1B1B">
                                    {linkedStory.headline}
                                  </h4>
                                </div>
                              </a>)}
                          </div>
                        </div>}
                    </div>
                    <ArticleFooter />
                  </>}
                {story['story-template'] === 'photo' && <>
                    {/* Headline */}
                    <div className="relative p-4 border-b border-DCDCDC">
                      {/* Bookmark/Reaction Icons & Share - Top Right */}
                      <div className="absolute top-4 right-4 z-10 flex items-center gap-1">
                        <MessageIconLogo id={`photo-${story.slug}`} variant="message-icon-3" slug={story.slug} category={BOOKMARK_CATEGORIES.PHOTOS} title={story.headline} thumbnailUrl={imageUrl} description={story.subheadline} articleUrl={`/${story.slug}`} />
                      </div>
                      {story.sections?.[0]?.name && !HIDDEN_CATEGORY_NAMES.includes(story.sections[0].name?.trim()) && <Link href={`/${getPathFromUrl(story.sections[0]?.['section-url'] || '')}`}>
 <h2 className="text-16-tamil-600 text-012061 mb-2 hover:underline cursor-pointer">{story.sections[0].name}</h2>
                        </Link>}
 <h1 className="text-24-tamil-700 text-1B1B1B mb-2">{story.headline}</h1>
                      {story.subheadline && <h2 className="text-18-tamil-400 text-4D4D4D mb-2">{story.subheadline}</h2>}
                    </div>

                    {/* Photo Carousel */}
                    <div className="border-b border-DCDCDC">
                      <PhotoCarousel heroImage={{
                  imageS3Key: story['hero-image-s3-key'],
                  imageMetadata: story['hero-image-metadata'],
                  title: story['hero-image-caption'] || '',
                  attribution: story['hero-image-attribution'] || ''
                }} photos={story.cards?.flatMap((card: any) => card['story-elements']?.map((element: any) => ({
                  id: `${card.id}-${element.id}`,
                  title: element.title,
                  imageS3Key: element['image-s3-key'],
                  text: element.text,
                  imageMetadata: element['image-metadata'],
                  attribution: element['image-attribution'] || ''
                })) || [])} maxHeight={575} containerClassName="aspect-[16/9] max-h-[400px]" />
                    </div>

                    {/* Author, Updated On and Share - after photo */}
                    <div className="p-4 border-b border-DCDCDC">
                      <div className="flex flex-col gap-1 mb-3">
                        {hasVisibleAuthors(story) && <div className="flex items-center gap-2">
                            {filterAuthors(story.authors)[0]?.['avatar-s3-key'] && <img src={getImageUrl(filterAuthors(story.authors)[0]['avatar-s3-key'])} alt={filterAuthors(story.authors)[0].name || 'Author'} className="w-8 h-8 rounded-full object-cover flex-shrink-0" />}
                            <div className="text-14-tamil-500 text-4D4D4D">
                              {filterAuthors(story.authors).map((author: any, idx: number) => <span key={author.id}>
                                  {idx > 0 && ', '}
                                  <Link href={`/author/${author.slug}`} className="text-14-tamil-600 sm:text-18-tamil-600 text-1B1B1B hover:text-012061">
                                    {author.name}
                                  </Link>
                                </span>)}
                            </div>
                          </div>}
                        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
                          <div className="flex items-center gap-1">
                            <span className="text-12-tamil-300 text-1B1B1B">Updated On :</span>
                            <span className="text-12-tamil-500 text-1B1B1B">{updatedAt}</span>
                          </div>
                          <ArticleShareButtons slug={story.slug} title={story.headline} className="!p-0 !gap-1" />
                        </div>
                      </div>
                    </div>
                    {promotionBlock}
                    {/* Story-level embed-js (video/tweet/instagram embed at story level) */}
                    {story['embed-js'] && <div className="border-b border-DCDCDC p-4">
                        {(() => {
                  try {
                    const decoded = atob(story['embed-js']);
                    if (decoded.includes('twitter-tweet') || decoded.includes('platform.twitter.com')) {
                      return <TweetEmbed embedJs={story['embed-js']} />;
                    }
                    if (decoded.includes('instagram-media') || decoded.includes('instagram.com')) {
                      return <InstagramEmbed embedJs={story['embed-js']} />;
                    }
                  } catch {
                    if (story['embed-js'].includes('twitter-tweet') || story['embed-js'].includes('platform.twitter.com')) {
                      return <TweetEmbed embedJs={story['embed-js']} />;
                    }
                    if (story['embed-js'].includes('instagram-media') || story['embed-js'].includes('instagram.com')) {
                      return <InstagramEmbed embedJs={story['embed-js']} />;
                    }
                  }
                  return <GumletEmbed embedJs={story['embed-js']} />;
                })()}
                      </div>}
                    {/* Story-level YouTube video */}
                    {story['embed-url'] && <div className="border-b border-DCDCDC">
                        <YouTubeThumbnail embedUrl={story['embed-url']} thumbnailUrl={imageUrl} title={story.headline} />
                      </div>}

                    {/* Summary and Story Elements */}
                    <div className="p-4 space-y-6">
                      {story.cards?.map((card: any, cardIdx: number) => <div key={cardIdx}>
                          {card['story-elements']?.map((element: any, elementIdx: number) => <div key={elementIdx} className="mb-6">
                              {element.subtype === 'summary' && element.text && <div>
 <h3 className="text-18-tamil-700 text-1B1B1B mb-2">சுருக்கம்</h3>
                                  <div className="text-18-tamil-400 text-1B1B1B mb-4 article-links [&_p]:mb-4" dangerouslySetInnerHTML={{
                        __html: processArticleLinks(element.text)
                      }} />
                                </div>}
                              {element.text && element.subtype !== 'summary' && element.subtype !== 'also-read' && element.type === 'text' && !element.metadata?.['promotional-message'] && <div className="text-18-tamil-400 text-1B1B1B article-links [&_p]:mb-4" dangerouslySetInnerHTML={{
                      __html: processArticleLinks(element.text)
                    }} />}
                              {element.text && element.metadata?.['promotional-message'] && <div className="text-14-tamil-400 article-links [&_p]:mb-4" style={{
                      color: '#00000099'
                    }} dangerouslySetInnerHTML={{
                      __html: processArticleLinks(element.text)
                    }} />}
                              {element.subtype === 'also-read' && element.text && (() => {
                      const linkedStoryId = element.metadata?.['linked-story-id'] || element['linked-story-id'];
                      const linkedStory = linkedStoryId && story['linked-stories']?.[linkedStoryId] || element.metadata?.['linked-story'];
                      if (linkedStory && linkedStory.slug) {
                        return <a href={`/${linkedStory.slug}`} className="flex flex-col sm:flex-row gap-3 border border-DCDCDC overflow-hidden hover:shadow-md transition-shadow my-3 p-4">
                                      {linkedStory['hero-image-s3-key'] && <div className="w-full sm:w-[150px] h-[160px] sm:h-[100px] flex-shrink-0">
                                          <img src={getImageUrl(linkedStory['hero-image-s3-key'])} alt={linkedStory.headline} className="w-full h-full object-cover" />
                                        </div>}
                                      <div className="p-3 flex-1 flex items-center">
 <h4 className="text-16-tamil-700 text-1B1B1B">
                                          {linkedStory.headline}
                                        </h4>
                                      </div>
                                    </a>;
                      }
                      return null;
                    })()}
                            </div>)}
                          {/* Card-based ad: ROS Inread (video ad) always after 1st card, subsequent ads only if card has text */}
                          {hasInlineAdCodes && (cardIdx === 0 || cardHasTextContent(card) && cardIdx > 0 && cardIdx % 2 === 0) && <InlineArticleAd rosInreadAdCode={rosInreadAdCode} multipleAdSlots={multipleAdSlots} inlinePosition={cardIdx === 0 ? 0 : Math.floor(cardIdx / 2)} adIndex={8000 + cardIdx} />}
                        </div>)}

                      {/* Linked Stories Section */}
                      {story['linked-stories'] && Object.keys(story['linked-stories']).length > 0 && <div className="mb-6">
                          <div className="grid grid-cols-1 gap-4">
                            {Object.entries(story['linked-stories']).filter(([key]) => !inlineAlsoReadIds.has(key)).map(([key, linkedStory]: [string, any]) => <a key={key} href={`/${linkedStory.slug}`} className="flex flex-col lg:flex-row gap-3 lg:gap-4 p-4 border border-DCDCDC overflow-hidden hover:shadow-md transition-shadow">
                                {linkedStory['hero-image-s3-key'] && <div className="w-full lg:w-[200px] h-[200px] lg:h-[120px] flex-shrink-0">
                                    <img src={getImageUrl(linkedStory['hero-image-s3-key'])} alt={linkedStory.headline} className="w-full h-full object-cover" />
                                  </div>}
                                <div className="p-3 lg:p-4 flex-1 flex items-center">
 <h4 className="text-16-tamil-700 lg:text-18-tamil-700 text-1B1B1B">
                                    {linkedStory.headline}
                                  </h4>
                                </div>
                              </a>)}
                          </div>
                        </div>}
                    </div>

                    <ArticleFooter />
                  </>}
                {story['story-template'] === 'interview' && <>
                    {/* Headline and Meta Info */}
                    <div className="relative p-4 border-b border-DCDCDC">
                      {/* Bookmark/Reaction Icons & Share - Top Right */}
                      <div className="absolute top-4 right-4 z-10 flex items-center gap-1">
                        <MessageIconLogo id={`interview-${story.slug}`} variant="message-icon-3" slug={story.slug} category={BOOKMARK_CATEGORIES.NEWS} title={story.headline} thumbnailUrl={imageUrl} description={story.subheadline} articleUrl={`/${story.slug}`} />
                      </div>
                      {story.sections?.[0]?.name && !HIDDEN_CATEGORY_NAMES.includes(story.sections[0].name?.trim()) && <Link href={`/${getPathFromUrl(story.sections[0]?.['section-url'] || '')}`}>
 <h2 className="text-16-tamil-600 text-012061 mb-2 hover:underline cursor-pointer">{story.sections[0].name}</h2>
                        </Link>}
 <h1 className="text-24-tamil-700 text-1B1B1B mb-2">{story.headline}</h1>
                      {story.subheadline && <h2 className="text-18-tamil-400 text-4D4D4D mb-4">{story.subheadline}</h2>}
                    </div>

                    {/* Hero Image */}
                    {imageUrl && <div className="border-b border-DCDCDC">
                        <img src={imageUrl} alt={story.headline || 'Interview'} className="w-full aspect-[16/9] max-h-[475px] object-cover" style={getFocusPointStyle(story['hero-image-metadata'])} />
                        {(story['hero-image-caption'] || imageAttribution) && <div className="p-2 text-12-tamil-400 sm:text-16-tamil-400">
                            <p>
                              {story['hero-image-caption'] && <span className="text-black">{story['hero-image-caption']}</span>}
                              {story['hero-image-caption'] && imageAttribution && ' - '}
                              {imageAttribution && <span style={{
                      color: '#00000099'
                    }}>{imageAttribution}</span>}
                            </p>
                          </div>}
                      </div>}

                    {/* Author and Updated On */}
                    <div className="p-4 border-b border-DCDCDC">
                      <div className="flex flex-col gap-1">
                        {hasVisibleAuthors(story) && <div className="flex items-center gap-2 mb-4">
                            {filterAuthors(story.authors)[0]?.['avatar-s3-key'] && <img src={getImageUrl(filterAuthors(story.authors)[0]['avatar-s3-key'])} alt={filterAuthors(story.authors)[0].name || 'Author'} className="w-8 h-8 rounded-full object-cover flex-shrink-0" />}
                            <div className="text-14-tamil-500 text-4D4D4D">
                              {filterAuthors(story.authors).map((author: any, idx: number) => <span key={author.id}>
                                  {idx > 0 && ', '}
                                  <Link href={`/author/${author.slug}`} className="text-14-tamil-600 sm:text-18-tamil-600 text-1B1B1B hover:text-012061">
                                    {author.name}
                                  </Link>
                                </span>)}
                            </div>
                          </div>}
                        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
                          <div className="flex items-center gap-1">
                            <span className="text-12-tamil-300 text-1B1B1B">Updated On :</span>
                            <span className="text-12-tamil-500 text-1B1B1B">{updatedAt}</span>
                          </div>
                          <ArticleShareButtons slug={story.slug} title={story.headline} className="!p-0 !gap-1" />
                        </div>
                      </div>
                    </div>
                    {promotionBlock}
                    {/* Story-level embed-js (video/tweet/instagram embed at story level) */}
                    {story['embed-js'] && <div className="border-b border-DCDCDC p-4">
                        {(() => {
                  try {
                    const decoded = atob(story['embed-js']);
                    if (decoded.includes('twitter-tweet') || decoded.includes('platform.twitter.com')) {
                      return <TweetEmbed embedJs={story['embed-js']} />;
                    }
                    if (decoded.includes('instagram-media') || decoded.includes('instagram.com')) {
                      return <InstagramEmbed embedJs={story['embed-js']} />;
                    }
                  } catch {
                    if (story['embed-js'].includes('twitter-tweet') || story['embed-js'].includes('platform.twitter.com')) {
                      return <TweetEmbed embedJs={story['embed-js']} />;
                    }
                    if (story['embed-js'].includes('instagram-media') || story['embed-js'].includes('instagram.com')) {
                      return <InstagramEmbed embedJs={story['embed-js']} />;
                    }
                  }
                  return <GumletEmbed embedJs={story['embed-js']} />;
                })()}
                      </div>}
                    {/* Story-level YouTube video */}
                    {story['embed-url'] && <div className="border-b border-DCDCDC">
                        <YouTubeThumbnail embedUrl={story['embed-url']} thumbnailUrl={imageUrl} title={story.headline} />
                      </div>}

                    {/* Interview Q&A from Cards */}
                    <div className="p-4 space-y-6">
                      {story.cards?.map((card: any, cardIdx: number) => <div key={cardIdx}>
                          <div>
                            {card['story-elements']?.filter((el: any) => el && (el.text || el.type || el.subtype)).map((element: any, elementIdx: number) => <div key={elementIdx} className="mb-6">
                                {element.type === 'jsembed' && element.subtype === 'tweet' && <TweetEmbed embedJs={element['embed-js']} />}
                                {element.type === 'jsembed' && element.subtype === 'instagram' && <InstagramEmbed embedJs={element['embed-js']} />}
                                {element.type === 'jsembed' && element.subtype !== 'tweet' && element.subtype !== 'instagram' && <VideoEmbed embedJs={element['embed-js']} type={element.type} subtype={element.subtype} />}
                                {element.type === 'youtube-video' && element['embed-url'] && <YouTubeThumbnail embedUrl={element['embed-url']} thumbnailUrl={imageUrl} title={element.title} />}
                                {element.subtype === 'question' && element.text ? (/* Question Design - Light Blue Background */
                      <div style={{
                        backgroundColor: '#E3F2FD',
                        padding: '16px',
                        borderRadius: '8px'
                      }}>
                                    <div style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: '12px'
                        }}>
                                      <span style={{
                            backgroundColor: '#1565C0',
                            color: 'white',
                            fontWeight: 'bold',
                            minWidth: '28px',
                            height: '28px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '4px',
                            fontSize: '16px',
                            flexShrink: 0
                          }}>Q</span>
                                      <div className="text-18-tamil-700 text-1B1B1B article-links [&_p]:mb-3 [&_p:last-child]:mb-0" style={{
                            flex: 1
                          }} dangerouslySetInnerHTML={{
                            __html: processArticleLinks(element.text)
                          }} />
                                    </div>
                                  </div>) : element.subtype === 'answer' && element.text ? (/* Answer Design - Light Cream/Beige Background */
                      <div style={{
                        backgroundColor: '#FFF3E0',
                        padding: '16px',
                        borderRadius: '8px'
                      }}>
                                    <div style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: '12px'
                        }}>
                                      <span style={{
                            backgroundColor: '#E65100',
                            color: 'white',
                            fontWeight: 'bold',
                            minWidth: '28px',
                            height: '28px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '4px',
                            fontSize: '16px',
                            flexShrink: 0
                          }}>A</span>
                                      <div className="text-18-tamil-400 text-1B1B1B article-links [&_p]:mb-3 [&_p:last-child]:mb-0" style={{
                            flex: 1
                          }} dangerouslySetInnerHTML={{
                            __html: processArticleLinks(element.text)
                          }} />
                                    </div>
                                  </div>) : element.type !== 'jsembed' && element.type !== 'youtube-video' && element.subtype !== 'question' && element.subtype !== 'answer' && element.subtype !== 'also-read' && !element.metadata?.['promotional-message'] && (/* Default Design */
                      <div className="space-y-4">
                                    {element.subtype === 'summary' && element.text && <div>
 <h3 className="text-18-tamil-700 text-1B1B1B mb-2">Summary</h3>
                                        <div className="text-18-tamil-400 text-1B1B1B mb-6 article-links [&_p]:mb-4" dangerouslySetInnerHTML={{
                            __html: processArticleLinks(element.text)
                          }} />
                                      </div>}
                                    {element.text && element.subtype !== 'summary' && <div className="text-18-tamil-400 text-1B1B1B article-links [&_p]:mb-4" dangerouslySetInnerHTML={{
                          __html: processArticleLinks(element.text)
                        }} />}
                                  </div>)}
                                {element.text && element.metadata?.['promotional-message'] && <div className="text-14-tamil-400 article-links [&_p]:mb-4" style={{
                        color: '#00000099'
                      }} dangerouslySetInnerHTML={{
                        __html: processArticleLinks(element.text)
                      }} />}
                                {element.subtype === 'also-read' && element.text && (() => {
                        const linkedStoryId = element.metadata?.['linked-story-id'] || element['linked-story-id'];
                        const linkedStory = linkedStoryId && story['linked-stories']?.[linkedStoryId] || element.metadata?.['linked-story'];
                        if (linkedStory && linkedStory.slug) {
                          return <a href={`/${linkedStory.slug}`} className="flex flex-col sm:flex-row gap-3 border border-DCDCDC overflow-hidden hover:shadow-md transition-shadow my-3 p-4">
                                        {linkedStory['hero-image-s3-key'] && <div className="w-full sm:w-[150px] h-[160px] sm:h-[100px] flex-shrink-0">
                                            <img src={getImageUrl(linkedStory['hero-image-s3-key'])} alt={linkedStory.headline} className="w-full h-full object-cover" />
                                          </div>}
                                        <div className="p-3 flex-1 flex items-center">
 <h4 className="text-16-tamil-700 text-1B1B1B">
                                            {linkedStory.headline}
                                          </h4>
                                        </div>
                                      </a>;
                        }
                        return null;
                      })()}
                              </div>)}
                          </div>
                          {/* Card-based ad: after 1st card, then every 2 cards */}
                          {hasInlineAdCodes && (cardIdx === 0 || cardIdx > 0 && cardIdx % 2 === 0) && <InlineArticleAd rosInreadAdCode={rosInreadAdCode} multipleAdSlots={multipleAdSlots} inlinePosition={cardIdx === 0 ? 0 : Math.floor(cardIdx / 2)} adIndex={5000 + cardIdx} />}
                        </div>)}

                      {/* Linked Stories Section */}
                      {story['linked-stories'] && Object.keys(story['linked-stories']).length > 0 && <div className="mb-6">
                          <div className="grid grid-cols-1 gap-4">
                            {Object.entries(story['linked-stories']).filter(([key]) => !inlineAlsoReadIds.has(key)).map(([key, linkedStory]: [string, any]) => <a key={key} href={`/${linkedStory.slug}`} className="flex flex-col lg:flex-row gap-3 lg:gap-4 p-4 border border-DCDCDC overflow-hidden hover:shadow-md transition-shadow">
                                {linkedStory['hero-image-s3-key'] && <div className="w-full lg:w-[200px] h-[200px] lg:h-[120px] flex-shrink-0">
                                    <img src={getImageUrl(linkedStory['hero-image-s3-key'])} alt={linkedStory.headline} className="w-full h-full object-cover" />
                                  </div>}
                                <div className="p-3 lg:p-4 flex-1 flex items-center">
 <h4 className="text-16-tamil-700 lg:text-18-tamil-700 text-1B1B1B">
                                    {linkedStory.headline}
                                  </h4>
                                </div>
                              </a>)}
                          </div>
                        </div>}
                    </div>
                    <ArticleFooter />
                  </>}
                {story['story-template'] === 'photo-visual' && <>
                    {/* Headline and Meta Info */}
                    <div className="relative p-4 border-b border-DCDCDC">
                      {/* Bookmark/Reaction Icons & Share - Top Right */}
                      <div className="absolute top-4 right-4 z-10 flex items-center gap-1">
                        <MessageIconLogo id={`photo-visual-${story.slug}`} variant="message-icon-3" slug={story.slug} category={BOOKMARK_CATEGORIES.PHOTOS} title={story.headline} thumbnailUrl={imageUrl} description={story.subheadline} articleUrl={`/${story.slug}`} />
                      </div>
                      {story.sections?.[0]?.name && !HIDDEN_CATEGORY_NAMES.includes(story.sections[0].name?.trim()) && <Link href={`/${getPathFromUrl(story.sections[0]?.['section-url'] || '')}`}>
 <h2 className="text-16-tamil-600 text-012061 mb-2 hover:underline cursor-pointer">{story.sections[0].name}</h2>
                        </Link>}
 <h1 className="text-24-tamil-700 text-1B1B1B mb-2">{story.headline}</h1>
                      {story.subheadline && <h2 className="text-18-tamil-400 text-4D4D4D">{story.subheadline}</h2>}
                    </div>

                    {/* Hero Image */}
                    {imageUrl && <div className="border-b border-DCDCDC">
                        <img src={imageUrl} alt={story.headline || 'Photo visual'} className="w-full aspect-[16/9] max-h-[475px] object-cover" style={getFocusPointStyle(story['hero-image-metadata'])} />
                        {(story['hero-image-caption'] || imageAttribution) && <div className="p-2 text-12-tamil-400 sm:text-16-tamil-400">
                            <p>
                              {story['hero-image-caption'] && <span className="text-black">{story['hero-image-caption']}</span>}
                              {story['hero-image-caption'] && imageAttribution && ' - '}
                              {imageAttribution && <span style={{
                      color: '#00000099'
                    }}>{imageAttribution}</span>}
                            </p>
                          </div>}
                      </div>}

                    {/* Author and Updated On - After Image */}
                    <div className="p-4 border-b border-DCDCDC">
                      <div className="flex flex-col gap-1">
                        {hasVisibleAuthors(story) && <div className="flex items-center gap-2 mb-4">
                            {filterAuthors(story.authors)[0]?.['avatar-s3-key'] && <img src={getImageUrl(filterAuthors(story.authors)[0]['avatar-s3-key'])} alt={filterAuthors(story.authors)[0].name || 'Author'} className="w-8 h-8 rounded-full object-cover flex-shrink-0" />}
                            <div className="text-14-tamil-500 text-4D4D4D">
                              {filterAuthors(story.authors).map((author: any, idx: number) => <span key={author.id}>
                                  {idx > 0 && ', '}
                                  <Link href={`/author/${author.slug}`} className="text-14-tamil-600 sm:text-18-tamil-600 text-1B1B1B hover:text-012061">
                                    {author.name}
                                  </Link>
                                </span>)}
                            </div>
                          </div>}
                        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
                          <div className="flex items-center gap-1">
                            <span className="text-12-tamil-300 text-1B1B1B">Updated On :</span>
                            <span className="text-12-tamil-500 text-1B1B1B">{updatedAt}</span>
                          </div>
                          <ArticleShareButtons slug={story.slug} title={story.headline} className="!p-0 !gap-1" />
                        </div>
                      </div>
                    </div>
                    {promotionBlock}

                    {showAudioPlayer && <AudioPlayer />}
                    {/* Story-level embed-js (video/tweet/instagram embed at story level) */}
                    {story['embed-js'] && <div className="border-b border-DCDCDC p-4">
                        {(() => {
                  try {
                    const decoded = atob(story['embed-js']);
                    if (decoded.includes('twitter-tweet') || decoded.includes('platform.twitter.com')) {
                      return <TweetEmbed embedJs={story['embed-js']} />;
                    }
                    if (decoded.includes('instagram-media') || decoded.includes('instagram.com')) {
                      return <InstagramEmbed embedJs={story['embed-js']} />;
                    }
                  } catch {
                    if (story['embed-js'].includes('twitter-tweet') || story['embed-js'].includes('platform.twitter.com')) {
                      return <TweetEmbed embedJs={story['embed-js']} />;
                    }
                    if (story['embed-js'].includes('instagram-media') || story['embed-js'].includes('instagram.com')) {
                      return <InstagramEmbed embedJs={story['embed-js']} />;
                    }
                  }
                  return <GumletEmbed embedJs={story['embed-js']} />;
                })()}
                      </div>}
                    {/* Story-level YouTube video */}
                    {story['embed-url'] && <div className="border-b border-DCDCDC">
                        <YouTubeThumbnail embedUrl={story['embed-url']} thumbnailUrl={imageUrl} title={story.headline} />
                      </div>}

                    {/* Photo Visual Gallery from Cards */}
                    <div className="p-4 space-y-6">
                      {story.cards?.map((card: any, cardIdx: number) => <div key={cardIdx}>
                          <div>
                            {card['story-elements']?.map((element: any, elementIdx: number) => <div key={elementIdx} className="mb-6">
                                {element.type === 'jsembed' && element.subtype === 'tweet' && <TweetEmbed embedJs={element['embed-js']} />}
                                {element.type === 'jsembed' && element.subtype === 'instagram' && <InstagramEmbed embedJs={element['embed-js']} />}
                                {element.type === 'jsembed' && element.subtype !== 'tweet' && element.subtype !== 'instagram' && <VideoEmbed embedJs={element['embed-js']} type={element.type} subtype={element.subtype} />}
                                {element.type === 'youtube-video' && element['embed-url'] && <YouTubeThumbnail embedUrl={element['embed-url']} thumbnailUrl={imageUrl} title={element.title} />}
                                {element['image-s3-key'] && <div className="mb-4">
                                    <div className="relative w-full h-[300px] sm:h-[400px] md:h-[470px] bg-gray-100 p-[5px] rounded overflow-hidden">
                                      <img src={getImageUrl(element['image-s3-key'])} alt="" className="absolute inset-0 w-full h-full object-cover blur-xl scale-110" aria-hidden="true" />
                                      <img src={getImageUrl(element['image-s3-key'])} alt={element.text || 'Photo visual'} className="relative w-full h-full object-contain" />
                                    </div>
                                    {(element.title || element['image-attribution']) && <div className="p-2 text-12-tamil-400 sm:text-16-tamil-400">
                                        <p>
                                          {element.title && <span className="text-black">{element.title}</span>}
                                          {element.title && element['image-attribution'] && ' - '}
                                          {element['image-attribution'] && <span style={{
                              color: '#00000099'
                            }}>{element['image-attribution']}</span>}
                                        </p>
                                      </div>}
                                  </div>}
                                {element.subtype === 'summary' && element.text && <div>
 <h3 className="text-18-tamil-700 text-1B1B1B mb-2">Summary</h3>
                                    <div className="text-18-tamil-400 text-1B1B1B mb-4 article-links [&_p]:mb-4" dangerouslySetInnerHTML={{
                          __html: processArticleLinks(element.text)
                        }} />
                                  </div>}
                                {element.text && element.subtype !== 'summary' && element.subtype !== 'also-read' && element.type !== 'jsembed' && element.type !== 'youtube-video' && !element.metadata?.['promotional-message'] && <div className="text-18-tamil-400 text-1B1B1B article-links [&_p]:mb-4" dangerouslySetInnerHTML={{
                        __html: processArticleLinks(element.text)
                      }} />}
                                {element.text && element.metadata?.['promotional-message'] && <div className="text-14-tamil-400 article-links [&_p]:mb-4" style={{
                        color: '#00000099'
                      }} dangerouslySetInnerHTML={{
                        __html: processArticleLinks(element.text)
                      }} />}
                                {element.subtype === 'also-read' && element.text && (() => {
                        const linkedStoryId = element.metadata?.['linked-story-id'] || element['linked-story-id'];
                        const linkedStory = linkedStoryId && story['linked-stories']?.[linkedStoryId] || element.metadata?.['linked-story'];
                        if (linkedStory && linkedStory.slug) {
                          return <a href={`/${linkedStory.slug}`} className="flex flex-col sm:flex-row gap-3 border border-DCDCDC overflow-hidden hover:shadow-md transition-shadow my-3 p-4">
                                        {linkedStory['hero-image-s3-key'] && <div className="w-full sm:w-[150px] h-[160px] sm:h-[100px] flex-shrink-0">
                                            <img src={getImageUrl(linkedStory['hero-image-s3-key'])} alt={linkedStory.headline} className="w-full h-full object-cover" />
                                          </div>}
                                        <div className="p-3 flex-1 flex items-center">
 <h4 className="text-16-tamil-700 text-1B1B1B">
                                            {linkedStory.headline}
                                          </h4>
                                        </div>
                                      </a>;
                        }
                        return null;
                      })()}
                                {/* Inline ad after every N text elements only (skip image-only elements) */}
                                {hasInlineAdCodes && shouldShowGalleryInlineAd(story, cardIdx, elementIdx) && <InlineArticleAd rosInreadAdCode={rosInreadAdCode} multipleAdSlots={multipleAdSlots} inlinePosition={getGalleryInlineAdPosition(story, cardIdx, elementIdx)} adIndex={6000 + cardIdx * 100 + elementIdx} />}
                              </div>)}
                          </div>
                        </div>)}

                      {/* Linked Stories Section */}
                      {story['linked-stories'] && Object.keys(story['linked-stories']).length > 0 && <div className="mb-6">
                          <div className="grid grid-cols-1 gap-4">
                            {Object.entries(story['linked-stories']).filter(([key]) => !inlineAlsoReadIds.has(key)).map(([key, linkedStory]: [string, any]) => <a key={key} href={`/${linkedStory.slug}`} className="flex flex-col lg:flex-row gap-3 lg:gap-4 p-4 border border-DCDCDC overflow-hidden hover:shadow-md transition-shadow">
                                {linkedStory['hero-image-s3-key'] && <div className="w-full lg:w-[200px] h-[200px] lg:h-[120px] flex-shrink-0">
                                    <img src={getImageUrl(linkedStory['hero-image-s3-key'])} alt={linkedStory.headline} className="w-full h-full object-cover" />
                                  </div>}
                                <div className="p-3 lg:p-4 flex-1 flex items-center">
 <h4 className="text-16-tamil-700 lg:text-18-tamil-700 text-1B1B1B">
                                    {linkedStory.headline}
                                  </h4>
                                </div>
                              </a>)}
                          </div>
                        </div>}
                    </div>
                    <ArticleFooter />
                  </>}
                {story['story-template'] === 'live-blog' && <>
                    {/* Headline and Meta Info with LIVE indicator */}
                    <div className="relative p-4 border-b border-DCDCDC">
                      {/* Bookmark/Reaction Icons & Share - Top Right */}
                      <div className="absolute top-4 right-4 z-10 flex items-center gap-1">
                        <MessageIconLogo id={`live-blog-${story.slug}`} variant="message-icon-3" slug={story.slug} category={BOOKMARK_CATEGORIES.NEWS} title={story.headline} thumbnailUrl={imageUrl} description={story.subheadline} articleUrl={`/${story.slug}`} />
                      </div>
                      {story.sections?.[0]?.name && !HIDDEN_CATEGORY_NAMES.includes(story.sections[0].name?.trim()) && <Link href={`/${getPathFromUrl(story.sections[0]?.['section-url'] || '')}`}>
 <h2 className="text-16-tamil-600 text-012061 mb-2 hover:underline cursor-pointer">{story.sections[0].name}</h2>
                        </Link>}
                      {/* LIVE Indicator + Headline — only show if live-blog is active and not closed */}
                      <div className="flex items-start gap-3 mb-2">
                        {story['is-live-blog'] && !story.metadata?.['is-closed'] && <span className="inline-flex items-center gap-2 px-3 py-1.5 text-white text-12-tamil-700 rounded-md flex-shrink-0 mt-1">
                            <span className="live-dot relative inline-flex rounded-full h-5 w-5 bg-red-600" />
                            {/* <span className="tracking-wider">LIVE</span> */}
                          </span>}
 <h1 className="text-24-tamil-700 text-1B1B1B">{story.headline}</h1>
                      </div>
                      {story.subheadline && <h2 className="text-18-tamil-400 text-4D4D4D">{story.subheadline}</h2>}
                    </div>

                    {/* Hero Image */}
                    {imageUrl && <div className="border-b border-DCDCDC">
                        <img src={imageUrl} alt={story.headline || 'Live Blog'} className="w-full aspect-[16/9] max-h-[475px] object-cover" style={getFocusPointStyle(story['hero-image-metadata'])} />
                        {(story['hero-image-caption'] || imageAttribution) && <div className="p-2 text-12-tamil-400 sm:text-16-tamil-400">
                            <p>
                              {story['hero-image-caption'] && <span className="text-black">{story['hero-image-caption']}</span>}
                              {story['hero-image-caption'] && imageAttribution && ' - '}
                              {imageAttribution && <span style={{
                      color: '#00000099'
                    }}>{imageAttribution}</span>}
                            </p>
                          </div>}
                      </div>}

                    {/* Author and Updated On - After Image */}
                    <div className="p-4 border-b border-DCDCDC">
                      <div className="flex flex-col gap-1">
                        {hasVisibleAuthors(story) && <div className="flex items-center gap-2 mb-4">
                            {filterAuthors(story['authors'])[0]?.['avatar-s3-key'] && <img src={getImageUrl(filterAuthors(story['authors'])[0]['avatar-s3-key'])} alt={filterAuthors(story['authors'])[0].name || 'Author'} className="w-8 h-8 rounded-full object-cover flex-shrink-0" />}
                            <div className="text-14-tamil-500 text-4D4D4D">
                              {filterAuthors(story['authors']).map((author: any, idx: number) => <span key={author.id}>
                                  {idx > 0 && ', '}
                                  <Link href={`/author/${author.slug}`} className="text-14-tamil-600 sm:text-18-tamil-600 text-1B1B1B hover:text-012061">
                                    {author.name}
                                  </Link>
                                </span>)}
                            </div>
                          </div>}
                        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
                          <div className="flex items-center gap-1">
                            <span className="text-12-tamil-300 text-1B1B1B">Updated On :</span>
                            <span className="text-12-tamil-500 text-1B1B1B">{updatedAt}</span>
                          </div>
                          <ArticleShareButtons slug={story.slug} title={story.headline} className="!p-0 !gap-1" />
                        </div>
                      </div>
                    </div>
                    {promotionBlock}

                    {/* Story-level embed-js (video/tweet/instagram embed at story level) */}
                    {story['embed-js'] && <div className="border-b border-DCDCDC p-4">
                        {(() => {
                  try {
                    const decoded = atob(story['embed-js']);
                    if (decoded.includes('twitter-tweet') || decoded.includes('platform.twitter.com')) {
                      return <TweetEmbed embedJs={story['embed-js']} />;
                    }
                    if (decoded.includes('instagram-media') || decoded.includes('instagram.com')) {
                      return <InstagramEmbed embedJs={story['embed-js']} />;
                    }
                  } catch {
                    if (story['embed-js'].includes('twitter-tweet') || story['embed-js'].includes('platform.twitter.com')) {
                      return <TweetEmbed embedJs={story['embed-js']} />;
                    }
                    if (story['embed-js'].includes('instagram-media') || story['embed-js'].includes('instagram.com')) {
                      return <InstagramEmbed embedJs={story['embed-js']} />;
                    }
                  }
                  return <GumletEmbed embedJs={story['embed-js']} />;
                })()}
                      </div>}

                    {/* Story-level YouTube video embed */}
                    {story['embed-url'] && <div className="border-b border-DCDCDC">
                        <YouTubeThumbnail embedUrl={story['embed-url']} thumbnailUrl={imageUrl} title={story.headline} />
                      </div>}

                    {/* Live Blog Updates from Cards */}
                    <div className="p-4 space-y-4">
                      {story.cards?.map((card: any, cardIdx: number) => {
                  // Get card timestamp for display
                  const cardTimestamp = card['card-event-at'] || card['card-added-at'];
                  // Find title element in card
                  const titleElement = card['story-elements']?.find((el: any) => el.type === 'title');
                  return <div key={cardIdx}>
                            <div className="relative pl-4 pb-4 mb-4 border-b border-DCDCDC">
                              {/* Share button - top right */}
                              <div className="absolute top-0 right-0">
                                <LiveBlogCardShare slug={story.slug} cardTitle={titleElement?.text || story.headline} />
                              </div>
                              {/* Card timestamp */}
                              {cardTimestamp && <div className="text-12-tamil-500 text-4D4D4D mb-2">
                                  {(() => {
                          const d = new Date(cardTimestamp);
                          const tamilMonths = ['ஜனவரி', 'பிப்ரவரி', 'மார்ச்', 'ஏப்ரல்', 'மே', 'ஜூன்', 'ஜூலை', 'ஆகஸ்ட்', 'செப்டம்பர்', 'அக்டோபர்', 'நவம்பர்', 'டிசம்பர்'];
                          const h = d.getHours() % 12 || 12;
                          const m = d.getMinutes().toString().padStart(2, '0');
                          const ampm = d.getHours() >= 12 ? 'pm' : 'am';
                          return `${h}:${m} ${ampm}, ${d.getDate()} ${tamilMonths[d.getMonth()]} ${d.getFullYear()}`;
                        })()}
                                </div>}

                              {/* Card title (from type: "title" element) */}
                              {titleElement?.text && <h3 className="text-20-tamil-700 text-1B1B1B mb-3">
                                  {titleElement.text}
                                </h3>}

                              {/* Card content elements */}
                              {card['story-elements']?.map((element: any, elementIdx: number) => <div key={elementIdx} className="mb-3">
                                  {/* Skip title elements as they're rendered above */}
                                  {element.type === 'title' && null}

                                  {/* Tweet embed */}
                                  {element.type === 'jsembed' && element.subtype === 'tweet' && <TweetEmbed embedJs={element['embed-js']} />}

                                  {/* Instagram embed */}
                                  {element.type === 'jsembed' && element.subtype === 'instagram' && <InstagramEmbed embedJs={element['embed-js']} />}

                                  {/* Other video embeds */}
                                  {element.type === 'jsembed' && element.subtype !== 'tweet' && element.subtype !== 'instagram' && <VideoEmbed embedJs={element['embed-js']} type={element.type} subtype={element.subtype} />}

                                  {/* YouTube video */}
                                  {element.type === 'youtube-video' && element['embed-url'] && <YouTubeThumbnail embedUrl={element['embed-url']} thumbnailUrl={imageUrl} title={element.title} />}

                                  {/* Image */}
                                  {element.type === 'image' && element['image-s3-key'] && <div className="mb-4">
                                      <div className="relative w-full h-[300px] sm:h-[400px] md:h-[470px] bg-gray-100 p-[5px] rounded overflow-hidden">
                                        <img src={getImageUrl(element['image-s3-key'])} alt="" className="absolute inset-0 w-full h-full object-cover blur-xl scale-110" aria-hidden="true" />
                                        <img src={getImageUrl(element['image-s3-key'])} alt={element['alt-text'] || element.title || 'Live blog image'} className="relative w-full h-full object-contain" />
                                      </div>
                                      {(element.title || element['image-attribution']) && <div className="p-2 text-12-tamil-400 sm:text-16-tamil-400">
                                          <p>
                                            {element.title && <span className="text-black">{element.title}</span>}
                                            {element.title && element['image-attribution'] && ' - '}
                                            {element['image-attribution'] && <span style={{
                                color: '#00000099'
                              }}>{element['image-attribution']}</span>}
                                          </p>
                                        </div>}
                                    </div>}

                                  {/* Summary text */}
                                  {element.subtype === 'summary' && element.text && <div className="text-18-tamil-400 text-1B1B1B article-links [&_p]:mb-4" dangerouslySetInnerHTML={{
                          __html: processArticleLinks(element.text)
                        }} />}

                                  {/* Also-read: render linked story inline */}
                                  {element.subtype === 'also-read' && element.text && (() => {
                          // Extract linked-story-id from metadata or text
                          const linkedStoryId = element.metadata?.['linked-story-id'] || element['linked-story-id'];
                          const linkedStory = linkedStoryId && story['linked-stories']?.[linkedStoryId] || element.metadata?.['linked-story'];
                          if (linkedStory && linkedStory.slug) {
                            return <a href={`/${linkedStory.slug}`} className="flex flex-col sm:flex-row gap-3 border border-DCDCDC overflow-hidden hover:shadow-md transition-shadow my-3 p-4">
                                          {linkedStory['hero-image-s3-key'] && <div className="w-full sm:w-[150px] h-[160px] sm:h-[100px] flex-shrink-0">
                                              <img src={getImageUrl(linkedStory['hero-image-s3-key'])} alt={linkedStory.headline} className="w-full h-full object-cover" />
                                            </div>}
                                          <div className="p-3 flex-1 flex items-center">
 <h4 className="text-16-tamil-700 text-1B1B1B">
                                              {linkedStory.headline}
                                            </h4>
                                          </div>
                                        </a>;
                          }
                          return null;
                        })()}

                                  {/* Regular text (not title, not summary, not also-read) */}
                                  {element.type === 'text' && element.subtype !== 'summary' && element.subtype !== 'also-read' && element.text && !element.metadata?.['promotional-message'] && <div className="text-18-tamil-400 text-1B1B1B article-links [&_p]:mb-4" dangerouslySetInnerHTML={{
                          __html: processArticleLinks(element.text)
                        }} />}
                                  {element.text && element.metadata?.['promotional-message'] && <div className="text-14-tamil-400 article-links [&_p]:mb-4" style={{
                          color: '#00000099'
                        }} dangerouslySetInnerHTML={{
                          __html: processArticleLinks(element.text)
                        }} />}

                                  {/* PDF file */}
                                  {element.type === 'file' && element['content-type'] === 'application/pdf' && <PdfFile fileName={element['file-name']} url={element.url} s3Key={element['s3-key']} />}

                                  {/* Table */}
                                  {element.type === 'data' && element.subtype === 'table' && <TableEmbed data={element.data} />}

                                </div>)}
                            </div>
                            {/* Card-based ad: after 1st card, then every 2 cards */}
                            {hasInlineAdCodes && (cardIdx === 0 || cardIdx > 0 && cardIdx % 2 === 0) && <InlineArticleAd rosInreadAdCode={rosInreadAdCode} multipleAdSlots={multipleAdSlots} inlinePosition={cardIdx === 0 ? 0 : Math.floor(cardIdx / 2)} adIndex={7000 + cardIdx} />}
                          </div>;
                })}
                    </div>

                    <ArticleFooter />
                  </>}
              </div>

              {/* Right: sidebar (30%) */}
              <div className="w-full lg:w-[30%] border-l border-DCDCDC">
                {/* First big ad - only render for active article to avoid GPT slot ID conflicts */}
                <div className="border-b border-DCDCDC article-page-big-ad-1 overflow-hidden">
                  {index === activeAdArticleIndex && <ArticleMultiAds key={`big-ad-1-${index}`} position="big-ad-1" />}
                </div>
                {/* Trending section - use native <a> tags instead of Next.js Link to avoid
                    router state mismatch from history.replaceState during infinite scroll */}
                <div className="border-b border-DCDCDC relative z-[1]">
                  <div className="border-b border-DCDCDC">
                    <OnesideText text={'தொடர்புடையது'} />
                  </div>
                  {articleRelated.map((relatedStory: any, rIndex: number) => relatedStory.slug ? <a key={`${relatedStory.slug}-${rIndex}`} href={`/${relatedStory.slug}`} className="block  transition-colors cursor-pointer">
                        <HorizontalSmallImageCategoryNews category={{
                  value: category
                }} title={{
                  value: relatedStory.headline
                }} timeAgo={{
                  value: formatTimeAgo(relatedStory['last-published-at'])
                }} imageSrc={{
                  value: relatedStory['hero-image-s3-key'] ? getImageUrl(relatedStory['hero-image-s3-key']) : FALLBACK_IMAGE
                }} imageMetadata={relatedStory['hero-image-metadata']} templatetype={{
                  value: relatedStory['story-template']
                }} />
                      </a> : <HorizontalSmallImageCategoryNews key={`related-${rIndex}`} category={{
                value: category
              }} title={{
                value: relatedStory.headline
              }} timeAgo={{
                value: formatTimeAgo(relatedStory['last-published-at'])
              }} imageSrc={{
                value: relatedStory['hero-image-s3-key'] ? getImageUrl(relatedStory['hero-image-s3-key']) : FALLBACK_IMAGE
              }} imageMetadata={relatedStory['hero-image-metadata']} templatetype={{
                value: relatedStory['story-template']
              }} />)}
                </div>
                {/* Small ad after trending - only render for active article to avoid GPT slot ID conflicts */}
                <div className="border-b border-DCDCDC article-page-small-1 overflow-hidden">
                  {index === activeAdArticleIndex && <ArticleMultiAds key={`small-1-${index}`} position="small-1" />}
                </div>
                {/* Videos section - sticky on desktop only, hidden for video, gumlet-video, photo and photo-visual templates */}
                {story['story-template'] !== 'video' && story['story-template'] !== 'gumlet-video' && story['story-template'] !== 'photo' && story['story-template'] !== 'photo-visual' && <div className="lg:sticky lg:top-10">
                    <div className="border-b border-DCDCDC">
                      <OnesideText text={'விடியோக்கள்'} />
                    </div>
                    <div className="border-b border-DCDCDC">
                      <HorizontalSmallVideoRightNews videos={videos.map(video => ({
                  title: {
                    hidden: false,
                    value: video.headline || "",
                    customClass: ""
                  },
                  slug: video.slug,
                  imageSrc: {
                    hidden: false,
                    value: video["hero-image-s3-key"] || "",
                    customClass: ""
                  },
                  timeAgo: {
                    hidden: false,
                    value: video["content-created-at"] || "",
                    customClass: ""
                  },
                  authorName: video["author-name"] || ""
                }))} />
                    </div>
                  </div>}
              </div>
            </div>

            {/* Full-width infinite ad below both columns. Mounted for every
                article in the list — each instance generates its own unique
                GPT div id (see ArticleMultiAds), so simultaneous slots don't
                conflict, and the ad stays anchored to its article when the
                reader scrolls back up. Lazy-loaded via IntersectionObserver
                inside ArticleMultiAds, so off-screen instances cost nothing. */}
            <div className="hidden md:block border-b border-DCDCDC article-page-infinite-ad overflow-hidden w-full">
              <ArticleMultiAds key={`infinite-ad-${index}`} position="infinite-ad" />
            </div>
          </div>;
    })}

      {/* Navigation arrows for single mode */}
      {articlePageStyle === 'single' && combinedArticles.length > 1 && <NavigationArrows />}

      {/* Sentinel for infinite scroll (only in infinite mode) */}
      {articlePageStyle === 'infinite' && (visibleCount < combinedArticles.length || hasMoreArticles) && <div ref={setSentinelRef} className="h-4" />}

      {/* Image and Video Section */}
      {/* <ImageVideo adType="article" /> */}
    </div>;
}